import React, { useContext, useEffect, useState } from 'react'
import PageHead from '../../Components/PageHead'
import { convertToBase64, getpostalcodes, isValidEmail, LogInSchoolID, MMDDYYYY } from '../../JS/Common';
import { ApiGetCall, ApiPostCall } from '../../JS/Connector';
import ReactCrop from "react-image-crop";
import "react-image-crop/dist/ReactCrop.css";
import AlertsComp from '../../Components/AlertsComp';
import { CheckValidation } from '../../Components/Validations';
import { useLocation, useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import { UserContext } from '../../App';
import { Accordion, OverlayTrigger, Popover } from 'react-bootstrap';
import { a } from '@table-library/react-table-library/index-a318de9b';
import { add } from 'lodash';
import Popup from '../../Components/Popup';
import BuildingAddressPopup from './BuildingAddressPopup';
import Cookies from 'js-cookie';

export default function SchoolProfile() {
    const [NewAlerts, setNewAlerts] = useState("");
    const [loading, setLoading] = useState(false);
    const [adperror, setAdperror] = useState("");
    const [asperror, setAsperror] = useState("");
    const [adhocerror, setAdhocerror] = useState("");
    const [coverageerror, setCoverageerror] = useState("");
    const location = useLocation();
    const { UserData, setUserData } = useContext(UserContext);
    const adminSchoolId = location?.state?.schoolid;
    const fromadminorschool = location?.state?.flag;
    const schoolname = location?.state?.schoolname;
    const navigate = useNavigate();
    const ShippingType = Cookies.get('ShippingType');

    const deviceDistricts = [
        { id: 1, name: "Acer" },
        { id: 2, name: "Apple" },
        { id: 3, name: "Asus" },
        { id: 4, name: "Dell" },
        { id: 5, name: "HP" },
        { id: 6, name: "Lenovo" },
        { id: 7, name: "Samsung" }
    ];
    const repairCoverage = [
        { id: 1, name: "ASP Warranty Repairs" },
        { id: 2, name: "Ad-Hoc Repairs" },
        { id: 3, name: "ADP" },
        { id: 4, name: "Device Complete Club" }
    ];
    const minimumRepairGrade = [
        { id: 1, name: "A" },
        { id: 2, name: "B" },
        { id: 3, name: "C" },
    ];
    const routeDay = [
        { id: 1, name: "Monday" },
        { id: 2, name: "Tuesday" },
        { id: 3, name: "Wednesday" },
        { id: 4, name: "Thursday" },
        { id: 5, name: "Friday" }
    ];
    const routeFrequency = [
        { id: 1, name: "Weekly" },
        { id: 2, name: "Bi-Weekly" },
        { id: 3, name: "Monthly" },
        { id: 4, name: "As-Needed" }
    ];
    const repairPriceTier = [
        { id: 1, name: "Bronze" },
        { id: 2, name: "Silver" },
        { id: 3, name: "Gold" },
        { id: 4, name: "Special" },
    ];
    const cosmeticDamage = [
        { id: 1, name: "Rubber Feet" },
        { id: 2, name: "Hinge Cover" },
        { id: 3, name: "Screw Cover" },
        { id: 4, name: "Stickers" }
    ];
    const exceedingCapHandling = [
        { id: 1, name: "Quote Repair" },
        { id: 2, name: "Quote Replacement" },
        { id: 3, name: "Send Back Unrepaired" },
        { id: 4, name: "eRecycle" },
        { id: 5, name: "Other" },
    ];
    const devicesTakeHome = [
        { id: 1, name: "Summer" },
        { id: 2, name: "Spring" },
        { id: 3, name: "Winter" },
        { id: 4, name: "Not Sent Home" },
    ];
    const quotingNeeded = [
        { id: 1, name: "Yes" },
        { id: 2, name: "No" },
    ];
    const additionalAssetManagement = [
        { id: 1, name: "Asset Panda" },
        { id: 2, name: "Incident IQ" },
        { id: 3, name: "One-to-One Plus" },
        { id: 4, name: "Self-Developed" },
        { id: 5, name: "Other" }
    ];
    const accountCreditUsage = [
        { id: 1, name: "Accessories" },
        { id: 2, name: "ADP" },
        { id: 3, name: "Buyback" },
        { id: 4, name: "Devices" },
        { id: 5, name: "Repairs" }
    ];
    const uncoveredDevices = [
        { id: 1, name: "Quote" },
        { id: 2, name: "Repair" },
        { id: 3, name: "Send Back" },
        { id: 4, name: "Other" },
    ];
    const methodOfContact = [
        { id: 1, name: "Call" },
        { id: 2, name: "Text" },
        { id: 3, name: "Email" },
    ];

    const [AllState, setallstate] = useState([]);
    const [postImage, setPostImage] = useState({ myFile: "" });
    const [showPopover, setShowPopover] = useState(false);
    const [relationshipshowPopover, setRelationshipshowPopover] = useState(false);


    const [SchoolProfile, setSchoolProfile] = useState({
        enrollment: "",
        customer: "",
        pricing: 0,
        domain: ''
    });
    const [shippingDetails, setShippingDetails] = useState({
        fedex_company_name: "",
        Phoneno: "",
        Street1: "",
        Street2: "",
        city: "",
        state: "",
        postalcode: "",
        shippingextension: "",
        pickuplocations: [],
        buildingname: ""
    });
    const [billingDetails, setBillingDetails] = useState({
        firstname: "",
        lastname: "",
        phoneno: "",
        email: "",
        accountcredit: "",
        companyname: "",
        street1: "",
        street2: "",
        city: '',
        state: '',
        postalcode: '',
        discoutpricing: '',
        accountcreditusage: [],
        billingextension: ''
    });
    const [contactInformation, setContactInformation] = useState({
        email: "",
        firstname: "",
        lastname: "",
        jobtitle: "",
        phonenumber: "",
        phonetype: "",
        contactextension: '',
        methodOfContact: []
    });
    const [deviceInformation, setDeviceInformation] = useState({
        weeklyrepairs: "",
        devicesindistrict: []
    });
    const [repairDetails, setRepairDetails] = useState({
        quotingNeeded: "",
        minRepairGrade: "",
        repairPriceTier: "",
        routeDay: '',
        routeFrequency: '',
        cosmeticDamageRepaird: '',
        cosmeticdamageNotes: '',
        selectedDamageRepaird: [],
        deductible: '',
        deductibleNotes: '',
        repairNotes: '',
        repairCoverage: [],
        uncovereddevice: '',
        repairCoverageDetails: [],
        uncovereddeviceNotes: '',
        repairpricetiernotes: '',
        additionalAssetNotes: '',
    });
    const [loanerAsset, setLoanerAsset] = useState({
        countofLoanerDevice: '',
        additionalAssets: []
    });
    const [k12TechData, setK12TechData] = useState({
        relationShipManager: '',
        locationManager: '',
        driver: '',
        startDate: '',
        relationShipManagerEmail: '',
        relationShipManagerContact: '',
        LocationManagerEmail: '',
        LocationManagerContact: '',
    });

    const [staffEmails, setStaffEmails] = useState([]);
    const [allTechnicians, setAllTechnicians] = useState([]);
    const [allk12Admins, setAllk12Admins] = useState([]);
    const [allPickUpLocations, setAllPickUpLocations] = useState([]);
    const [errors, setErrors] = useState({});
    const [ASProws, setASProws] = useState([]);
    const [ADProws, setADProws] = useState([]);
    const [EmailValidation, setEmailValidation] = useState('');
    const [repairCoverageData, setRepairCoverageData] = useState({
        adhoc_carted: 0,
        adhoc_cases: 0,
        adhoc_screen: 0,
        adhoc_id: 0,
        parental_carted: 0,
        parental_cases: 0,
        parental_screen: 0,
        parental_id: 0
    })
    const [logins, setLogins] = useState([]);
    const [activeKeys, setActiveKeys] = useState(['0', '1', '2']);
    const [billingCityTouched, setBillingCityTouched] = useState(false);
    const [billingStateTouched, setBillingStateTouched] = useState(false);
    const [billingZipTouched, setBillingZipTouched] = useState(false);
    const [sameAddress, setSameAddress] = useState(false);
    const [repairCapRows, setRepairCapRows] = useState([]);
    const [mailingaddress, setMailingAddress] = useState(0);
    const [mainshippinglocation, setMainShippingLocation] = useState(0);
    const [showAddressPopover, setShowAddressPopover] = useState(false);

    const [showSecondary, setShowSecondary] = useState(false);
    const [showRepair, setShowRepair] = useState(false);
    const [buildingAddressPopup, setBuildingAddressPopup] = useState(false);
    const [selectedBuildingAddress, setSelectedBuildingAddress] = useState({});
    const [deviceloginerror, setDeviceloginerror] = useState("");
    const [secondaryContactInformation, setSecondaryContactInformation] = useState({
        email: "", firstname: "", lastname: "", jobtitle: "", phonenumber: "",
        contactextension: "", phonetype: "", methodOfContact: []
    });

    const [repairContactInformation, setRepairContactInformation] = useState({
        email: "", firstname: "", lastname: "", jobtitle: "", phonenumber: "",
        contactextension: "", phonetype: "", methodOfContact: []
    });

    useEffect(() => {
        getpostalcodes(setallstate);
    }, []);
    useEffect(() => {
        getSchoolProfileInfo();
    }, [LogInSchoolID, adminSchoolId])

    async function getSchoolProfileInfo() {
        var sId = fromadminorschool == 2 ? adminSchoolId : LogInSchoolID;
        setLoading(true);
        await ApiGetCall("/schoolProfileInformation/" + sId).then((result) => {
            if (result == undefined || result == "") {
                alert("Something went wrong");
            } else {
                const responseRs = JSON.parse(result);
                setLoading(false);
                setAllPickUpLocations(responseRs?.allBuilding);
                setPostImage({ ...postImage, myFile: responseRs?.logo?.logo_path })
                setMailingAddress(responseRs?.schoolProfile?.mailing_address)
                setMainShippingLocation(responseRs?.schoolProfile?.main_shipping_location)
                setSchoolProfile({
                    ...SchoolProfile,
                    enrollment: responseRs?.schoolProfile?.enrollment,
                    customer: responseRs?.schoolProfile?.customer,
                    pricing: responseRs?.schoolProfile?.default_pricing,
                    domain: responseRs?.schoolProfile?.domain,
                });
                var FedexCompanyName = responseRs?.schoolShippingAddress?.fedex_company_name ?
                    responseRs?.schoolShippingAddress?.fedex_company_name :
                    fromadminorschool == 2 ? schoolname :
                        UserData.schoolname;
                var BillingFedexCompanyName = responseRs?.schoolBillingAddress?.fedex_company_name ?
                    responseRs?.schoolBillingAddress?.fedex_company_name :
                    fromadminorschool == 2 ? schoolname :
                        UserData.schoolname;
                setShippingDetails({
                    ...shippingDetails, fedex_company_name: FedexCompanyName,
                    Phoneno: responseRs?.schoolShippingAddress?.phone_num, Street1: responseRs?.schoolShippingAddress?.street_line,
                    Street2: responseRs?.schoolShippingAddress?.street_line2, city: responseRs?.schoolShippingAddress?.city,
                    state: responseRs?.schoolShippingAddress?.state_or_province_code, postalcode: responseRs?.schoolShippingAddress?.postal_code,
                    shippingextension: responseRs?.schoolShippingAddress?.phone_num_extension,
                    pickuplocations: responseRs?.schoolProfile?.pick_up_location,
                });
                if (responseRs?.schoolBillingAddress == null) {
                    setBillingDetails({
                        ...billingDetails,
                        phoneno: responseRs?.schoolShippingAddress?.phone_num,
                        companyname: FedexCompanyName,
                        street1: responseRs?.schoolShippingAddress?.street_line,
                        street2: responseRs?.schoolShippingAddress?.street_line2,
                        city: responseRs?.schoolShippingAddress?.city,
                        state: responseRs?.schoolShippingAddress?.state_or_province_code,
                        postalcode: responseRs?.schoolShippingAddress?.postal_code,
                        billingextension: responseRs?.schoolShippingAddress?.phone_num_extension
                    })
                    if (!responseRs?.schoolShippingAddress?.city) {
                        setBillingCityTouched(false);
                    } else {
                        setBillingCityTouched(true);
                    }
                    if (!responseRs?.schoolShippingAddress?.state_or_province_code) {
                        setBillingStateTouched(false);
                    } else {
                        setBillingStateTouched(true);
                    }
                    if (!responseRs?.schoolShippingAddress?.postal_code) {
                        setBillingZipTouched(false);
                    } else {
                        setBillingZipTouched(true);
                    }
                } else {
                    setBillingDetails({
                        ...billingDetails, firstname: responseRs?.schoolProfile?.billing_contact?.first_name,
                        lastname: responseRs?.schoolProfile?.billing_contact?.last_name,
                        phoneno: responseRs?.schoolBillingAddress?.phone_num, email: responseRs?.schoolProfile?.billing_contact?.email,
                        companyname: BillingFedexCompanyName, street1: responseRs?.schoolBillingAddress?.street_line,
                        street2: responseRs?.schoolBillingAddress?.street_line2, city: responseRs?.schoolBillingAddress?.city,
                        state: responseRs?.schoolBillingAddress?.state_or_province_code, postalcode: responseRs?.schoolBillingAddress?.postal_code,
                        accountcredit: responseRs?.schoolProfile?.billing_account_credit,
                        accountcreditusage: responseRs?.schoolProfile ? responseRs?.schoolProfile?.billing_account_credit_usage_array : [],
                        discoutpricing: responseRs?.schoolProfile?.special_discount,
                        billingextension: responseRs?.schoolProfile?.billing_contact?.phone_number_ext
                    });
                    if (!responseRs?.schoolBillingAddress?.city) {
                        setBillingCityTouched(false);
                    } else {
                        setBillingCityTouched(true);
                    }
                    if (!responseRs?.schoolBillingAddress?.state_or_province_code) {
                        setBillingStateTouched(false);
                    } else {
                        setBillingStateTouched(true);
                    }
                    if (!responseRs?.schoolBillingAddress?.postal_code) {
                        setBillingZipTouched(false);
                    } else {
                        setBillingZipTouched(true);
                    }
                }

                const matchingStaff = responseRs?.allStaffEmails.find(staff => staff?.email == responseRs?.admin.email);
                if (responseRs?.schoolProfile?.main_contact) {
                    setContactInformation({
                        ...contactInformation,
                        email: responseRs?.schoolProfile?.main_contact?.email,
                        firstname: responseRs?.schoolProfile?.main_contact?.first_name,
                        lastname: responseRs?.schoolProfile?.main_contact?.last_name,
                        jobtitle: responseRs?.schoolProfile?.main_contact?.job_title,
                        phonenumber: responseRs?.schoolProfile?.main_contact?.phone_number,
                        phonetype: responseRs?.schoolProfile?.main_contact?.phone_type,
                        contactextension: responseRs?.schoolProfile?.main_contact?.phone_number_ext,
                        methodOfContact: responseRs?.schoolProfile?.method_of_contact_main_array
                    });
                } else {
                    setContactInformation({
                        ...contactInformation,
                        email: matchingStaff?.email,
                        firstname: matchingStaff?.first_name,
                        lastname: matchingStaff?.last_name,
                        jobtitle: matchingStaff?.job_title,
                        phonenumber: matchingStaff?.phone_number,
                        phonetype: matchingStaff?.phone_type,
                        contactextension: matchingStaff?.phone_number_ext
                    });
                }
                if (responseRs?.schoolProfile?.secondary_contact) {
                    setShowSecondary(true);
                    setSecondaryContactInformation({
                        ...secondaryContactInformation,
                        email: responseRs?.schoolProfile?.secondary_contact?.email,
                        firstname: responseRs?.schoolProfile?.secondary_contact?.first_name,
                        lastname: responseRs?.schoolProfile?.secondary_contact?.last_name,
                        jobtitle: responseRs?.schoolProfile?.secondary_contact?.job_title,
                        phonenumber: responseRs?.schoolProfile?.secondary_contact?.phone_number,
                        phonetype: responseRs?.schoolProfile?.secondary_contact?.phone_type,
                        contactextension: responseRs?.schoolProfile?.secondary_contact?.phone_number_ext,
                        methodOfContact: responseRs?.schoolProfile?.method_of_contact_secondary_array
                    });
                }
                if (responseRs?.schoolProfile?.repair_contact) {
                    setShowRepair(true);
                    setRepairContactInformation({
                        ...repairContactInformation,
                        email: responseRs?.schoolProfile?.repair_contact?.email,
                        firstname: responseRs?.schoolProfile?.repair_contact?.first_name,
                        lastname: responseRs?.schoolProfile?.repair_contact?.last_name,
                        jobtitle: responseRs?.schoolProfile?.repair_contact?.job_title,
                        phonenumber: responseRs?.schoolProfile?.repair_contact?.phone_number,
                        phonetype: responseRs?.schoolProfile?.repair_contact?.phone_type,
                        contactextension: responseRs?.schoolProfile?.repair_contact?.phone_number_ext,
                        methodOfContact: responseRs?.schoolProfile?.method_of_contact_repair_array
                    });
                }
                setK12TechData({
                    ...k12TechData, relationShipManager: responseRs?.schoolProfile?.relation_manager?.id,
                    locationManager: responseRs?.schoolProfile?.location_manager?.id,
                    driver: responseRs?.schoolProfile?.driver?.id, startDate: responseRs?.schoolProfile?.k12_team_start_date,
                    relationShipManagerEmail: responseRs?.schoolProfile?.relation_manager?.email, relationShipManagerContact: responseRs?.schoolProfile?.relation_manager?.phone_number,
                    LocationManagerContact: responseRs?.schoolProfile?.location_manager?.phone_number, LocationManagerEmail: responseRs?.schoolProfile?.location_manager?.email
                });
                if (responseRs?.schoolProfile?.repair_coverage_details?.length > 0) {
                    const aspRows = responseRs?.schoolProfile?.repair_coverage_details
                        .filter(item => item.type == 1) // Filter ASP data
                        .map(item => ({
                            deviceType: item.device_type || "",
                            deviceModel: item.device_model || "",
                            coverageType: item.coverage_type || "",
                            startDate: item.start_date || "",
                            endDate: item.end_date || "",
                            carted: item.carted || 0,
                            cases: item.cases || 0,
                            screen: item.screen || 0,
                            id: item.id || 0
                        }));

                    const adpRows = responseRs?.schoolProfile?.repair_coverage_details
                        .filter(item => item.type == 3) // Filter ADP data (all other types)
                        .map(item => ({
                            deviceType: item.device_type || "",
                            deviceModel: item.device_model || "",
                            startDate: item.start_date || "",
                            endDate: item.end_date || "",
                            carted: item.carted || 0,
                            cases: item.cases || 0,
                            screen: item.screen || 0,
                            id: item.id || 0
                        }));

                    const adhocRows = responseRs?.schoolProfile?.repair_coverage_details
                        .filter(item => item.type == 2) // Filter ADP data (all other types)
                        .map(item => ({
                            carted: item.carted || 0,
                            cases: item.cases || 0,
                            screen: item.screen || 0,
                            id: item.id || 0
                        }));
                    const coverageRows = responseRs?.schoolProfile?.repair_coverage_details
                        .filter(item => item.type == 4) // Filter ADP data (all other types)
                        .map(item => ({
                            carted: item.carted || 0,
                            cases: item.cases || 0,
                            screen: item.screen || 0,
                            id: item.id || 0
                        }));

                    setRepairCoverageData({
                        ...repairCoverageData, adhoc_carted: adhocRows[0]?.carted, adhoc_cases: adhocRows[0]?.cases, adhoc_screen: adhocRows[0]?.screen, parental_carted: coverageRows[0]?.carted, parental_cases: coverageRows[0]?.cases, parental_screen: coverageRows[0]?.screen,
                        adhoc_id: adhocRows[0]?.id, parental_id: coverageRows[0]?.id
                    })
                    if (aspRows.length == 0) {
                        setASProws([{ deviceType: 0, deviceModel: "", coverageType: "", startDate: "", endDate: "", carted: 0, cases: 0, screen: 0, id: 0 }]);
                    } else {
                        setASProws([...aspRows]);
                    }

                    if (adpRows.length == 0) {
                        setADProws([{ deviceType: 0, deviceModel: "", startDate: "", endDate: "", carted: 0, cases: 0, screen: 0, id: 0 }]);
                    } else {
                        setADProws([...adpRows]);
                    }
                } else {
                    setASProws([{ deviceType: 0, deviceModel: "", coverageType: "", startDate: "", endDate: "", carted: 0, cases: 0, screen: 0, id: 0 }]);
                    setADProws([{ deviceType: 0, deviceModel: "", startDate: "", endDate: "", carted: 0, cases: 0, screen: 0, id: 0 }]);
                }

                setRepairDetails({
                    ...repairDetails,
                    quotingNeeded: responseRs?.schoolProfile?.needs_quoted,
                    minRepairGrade: responseRs?.schoolProfile?.minimum_repair_grade,
                    repairPriceTier: responseRs?.schoolProfile?.repair_price_tier,
                    routeDay: responseRs?.schoolProfile?.route_day,
                    routeFrequency: responseRs?.schoolProfile?.route_frequency,
                    repairNotes: responseRs?.schoolProfile?.repair_notes,
                    repairCoverage: responseRs?.schoolProfile ? responseRs?.schoolProfile?.repair_coverage_array : [],
                    uncovereddevice: responseRs?.schoolProfile?.uncover_device_repair_actions,
                    cosmeticDamageRepaird: responseRs?.schoolProfile?.cosmetic_damage_repaired,
                    selectedDamageRepaird: responseRs?.schoolProfile?.cosmetic_damage_repaired_options_array,
                    cosmeticdamageNotes: responseRs?.schoolProfile?.cosmetic_damage_notes,
                    deductible: responseRs?.schoolProfile?.deductible,
                    deductibleNotes: responseRs?.schoolProfile?.deductible_notes,
                    uncovereddeviceNotes: responseRs?.schoolProfile?.uncover_device_repair_note,
                    repairpricetiernotes: responseRs?.schoolProfile?.repair_price_tier_notes,
                    additionalAssetNotes: responseRs?.schoolProfile?.additional_asset_management_note,
                });
                setLoanerAsset({
                    ...loanerAsset,
                    countofLoanerDevice: responseRs?.schoolProfile?.loaner_device_ratio,
                    additionalAssets: responseRs?.schoolProfile ?
                        responseRs?.schoolProfile?.additional_asset_management_array : []
                })
                setStaffEmails(responseRs?.allStaffEmails)
                setAllTechnicians(responseRs?.allTechnicians)
                setAllk12Admins(responseRs?.allAdmins)
                setDeviceInformation({
                    ...deviceInformation, weeklyrepairs: responseRs?.weeklyRepairsCount,
                    devicesindistrict: responseRs?.schoolProfile ? responseRs?.schoolProfile?.devices_in_district_array : []
                })
                const deviceTypeMap = {
                    1: "Chromebook",
                    2: "Windows",
                    3: "iPad",
                    4: "MacBook"
                };
                const groupedLogins = responseRs?.schoolProfile?.device_credential_detail?.reduce((acc, item) => {
                    const deviceName = deviceTypeMap[item.device_type] || "Unknown";
                    let existingDevice = acc.find(d => d.device === deviceName);

                    if (existingDevice) {
                        existingDevice.credentials.push({ id: item.id, uniqueId: item.id, username: item.user_name, password: item.password, flag: 1 });
                    } else {
                        acc.push({
                            id: item.device_type,
                            device: deviceName,
                            uniqueId: item.id,
                            credentials: [{ id: item.id, username: item.user_name, password: item.password, flag: 1 }]
                        });
                    }

                    return acc;
                }, []);

                setLogins(responseRs?.schoolProfile?.device_credential_detail?.length > 0 ? groupedLogins : [
                    { id: 0, device: "Chromebook", credentials: [{ id: 0, username: "", password: "", flag: 0 }] }
                ]);
                if (responseRs?.schoolProfile?.repair_cap_details?.length > 0) {
                    const capRows = responseRs.schoolProfile.repair_cap_details.map((item) => ({
                        deviceType: item.device_type || "",
                        capAmount: item.repair_cap || "",
                        capexceeding: item.exceeding_cap_handling || "",
                        id: item.id || 0,
                        flag: 2
                    }));
                    setRepairCapRows([...capRows]);
                } else {
                    setRepairCapRows([{ deviceType: "", capAmount: "", capexceeding: "", id: 0, flag: 1 }]);
                }

            }
        });
    }
    const handleDeviceDistrictCheckboxChange = (e, id) => {
        setDeviceInformation((prevState) => {
            const existingUsage = prevState?.devicesindistrict ?? [];
            const isChecked = e.target.checked;
            const idString = String(id); // Convert ID to string
            return {
                ...prevState,
                devicesindistrict: isChecked
                    ? [...existingUsage.map(String), idString] // Convert all existing values to strings
                    : existingUsage.filter((item) => String(item) !== idString) // Ensure filtering works correctly
            };
        });
    };
    const handleCosmeticDamageCheckboxChange = (e, id) => {
        setRepairDetails((prevState) => {
            const existingUsage = prevState?.selectedDamageRepaird ?? [];
            const isChecked = e.target.checked;
            const idString = String(id);

            return {
                ...prevState,
                selectedDamageRepaird: isChecked
                    ? [...existingUsage.map(String), idString] // Add ID if checked
                    : existingUsage.filter((item) => String(item) !== idString) // Remove if unchecked
            };
        });
    };
    const handleRepairCoverageCheckboxChange = (e, id) => {
        setRepairDetails((prevState) => {
            const existingUsage = prevState?.repairCoverage ?? [];
            const isChecked = e.target.checked;
            const idString = String(id);
            return {
                ...prevState,
                repairCoverage: isChecked
                    ? [...existingUsage.map(String), idString] // Add ID if checked
                    : existingUsage.filter((item) => String(item) !== idString) // Remove if unchecked
            };
        });
    };
    const handleAdditionalAssetManagementCheckboxChange = (e, id) => {
        setLoanerAsset((prevState) => {
            const existingUsage = prevState?.additionalAssets ?? [];
            const isChecked = e.target.checked;
            const idString = String(id);
            return {
                ...prevState,
                additionalAssets: isChecked
                    ? [...existingUsage.map(String), idString] // Add ID if checked
                    : existingUsage.filter((item) => String(item) !== idString) // Remove if unchecked
            };
        });
    };
    const handleMethodOfContactCheckboxChange = (e, id) => {
        setContactInformation((prevState) => {
            const existingUsage = prevState?.methodOfContact ?? [];
            const isChecked = e.target.checked;
            const idString = String(id);
            return {
                ...prevState,
                methodOfContact: isChecked
                    ? [...existingUsage.map(String), idString] // Add ID if checked
                    : existingUsage.filter((item) => String(item) !== idString) // Remove if unchecked
            };
        });
    };
    const handleMethodOfSecondaryContactCheckboxChange = (e, id) => {
        setSecondaryContactInformation((prevState) => {
            const existingUsage = prevState?.methodOfContact ?? [];
            const isChecked = e.target.checked;
            const idString = String(id);
            return {
                ...prevState,
                methodOfContact: isChecked
                    ? [...existingUsage.map(String), idString] // Add ID if checked
                    : existingUsage.filter((item) => String(item) !== idString) // Remove if unchecked
            };
        });
    };
    const handleMethodOfRepairContactCheckboxChange = (e, id) => {
        setRepairContactInformation((prevState) => {
            const existingUsage = prevState?.methodOfContact ?? [];
            const isChecked = e.target.checked;
            const idString = String(id);
            return {
                ...prevState,
                methodOfContact: isChecked
                    ? [...existingUsage.map(String), idString] // Add ID if checked
                    : existingUsage.filter((item) => String(item) !== idString) // Remove if unchecked
            };
        });
    };
    const handleASPRepairCoverageChange = (index, field, value) => {
        const newRows = [...ASProws];
        newRows[index][field] = value;
        setASProws(newRows);
    };
    const handleAddNewASPRows = () => {
        const lastRow = ASProws[ASProws.length - 1];
        const isRowValid = lastRow.deviceType != 0 &&
            lastRow.carted != 0 &&
            lastRow.cases != 0 &&
            lastRow.screen != 0 &&
            lastRow.deviceModel &&
            lastRow.coverageType &&
            lastRow.startDate &&
            lastRow.endDate;

        if (isRowValid) {
            setASProws([
                ...ASProws,
                {
                    deviceType: 0,
                    deviceModel: "",
                    coverageType: "",
                    startDate: "",
                    endDate: "",
                    carted: 0,
                    cases: 0,
                    screen: 0,
                },
            ]);
            setAsperror(""); // Clear any previous error
        } else {
            setAsperror(ASProws.length - 1); // Set error index instead of message
        }
    };

    const handleADPRepairCoverageChange = (index, field, value) => {
        const newRows = [...ADProws];
        newRows[index][field] = value;
        setADProws(newRows);
    };
    const handleAddNewADPRows = () => {
        const lastRow = ADProws[ADProws.length - 1];
        const isRowValid = lastRow.deviceType != 0 &&
            lastRow.carted != 0 &&
            lastRow.cases != 0 &&
            lastRow.screen != 0 &&
            lastRow.deviceModel &&
            lastRow.startDate &&
            lastRow.endDate;

        if (isRowValid) {
            setADProws([
                ...ADProws,
                {
                    deviceType: 0,
                    deviceModel: "",
                    startDate: "",
                    endDate: "",
                    carted: 0,
                    cases: 0,
                    screen: 0,
                },
            ]);
            setAdperror(""); // Clear any previous error
        } else {
            setAdperror(ADProws.length - 1); // Set error index instead of message
        }

    }
    const addLogin = () => {
        setDeviceloginerror("")
        // Check if any existing login is incomplete
        for (let login of logins) {
            if (login.id === 0) {
                setDeviceloginerror("Please select a device for all existing entries.");
                return;
            }
            for (let cred of login.credentials) {
                if (cred.flag !== 2 && (!cred.username.trim() || !cred.password.trim())) {
                    setDeviceloginerror("Please fill out all username and password fields.");
                    return;
                }
            }
        }

        // Add new login row
        const newLogin = {
            uniqueId: Date.now(), // or use a UUID lib
            id: 0,
            device: "",
            credentials: [{
                id: 0, // You may want to generate a unique ID here
                username: '',
                password: '',
                flag: 0
            }]
        };

        setLogins([...logins, newLogin]);
    };

    const updateLogin = (uniqueId, field, value) => {
        setLogins(logins.map(login =>
            login.uniqueId === uniqueId ? { ...login, [field]: value } : login
        ));
    };

    const addCredential = (loginUniqueId) => {
        const newCredential = {
            id: Date.now() + Math.random(), // unique ID
            uniqueId: Date.now(),
            username: '',
            password: '',
            showPassword: false,
            flag: 0
        };
        setLogins(prev =>
            prev.map(login =>
                login.uniqueId === loginUniqueId
                    ? { ...login, credentials: [...login.credentials, newCredential] }
                    : login
            )
        );
    };
    const updateCredential = (loginUniqueId, credId, field, value) => {
        setLogins(logins.map(login =>
            login.uniqueId == loginUniqueId
                ? { ...login, credentials: login.credentials.map(cred => cred.id == credId ? { ...cred, [field]: value } : cred) }
                : login
        ));
    };
    const removeCredential = (loginUniqueId, credId) => {
        setLogins(prev =>
            prev.map(login =>
                login.uniqueId === loginUniqueId
                    ? {
                        ...login,
                        credentials: credId === 0
                            ? login.credentials.filter(cred => cred.id !== credId)
                            : login.credentials.map(cred =>
                                cred.id === credId ? { ...cred, flag: 2 } : cred
                            )
                    }
                    : login
            )
        );
    };
    const togglePasswordVisibility = (loginUniqueId, credId) => {
        setLogins((prevLogins) =>
            prevLogins.map((login) =>
                login.uniqueId === loginUniqueId
                    ? {
                        ...login,
                        credentials: login.credentials.map((cred) =>
                            cred.id === credId ? { ...cred, showPassword: !cred.showPassword } : cred
                        ),
                    }
                    : login
            )
        );
    };
    const validateRequiredFieldsInDiv = (divId, customValidator = null) => {
        const container = document.getElementById(divId);
        if (!container) return false;

        let isValid = true;
        let firstErrorField = null;

        container.querySelectorAll('[required]').forEach((field) => {
            field.classList.remove('is-invalid');
        });

        container.querySelectorAll('[required]').forEach((field) => {
            if (!field.value.trim()) {
                field.classList.add('is-invalid');
                if (!firstErrorField) firstErrorField = field;
                isValid = false;
            }
        });

        if (customValidator) {
            const { success, firstErrorSelector } = customValidator();
            if (!success) {
                isValid = false;
                const field = document.querySelector(firstErrorSelector);
                if (field) {
                    field.scrollIntoView({ behavior: 'smooth', block: 'center' });
                    field.focus();
                    return false;
                }
            }
        }

        if (firstErrorField) {
            firstErrorField.scrollIntoView({ behavior: 'smooth', block: 'center' });
            firstErrorField.focus();
            return false;
        }

        return true;
    };

    const validateMainContactExtras = () => {
        let errors = {};
        let firstErrorSelector = null;
        let success = true;
        if (contactInformation?.methodOfContact?.length === 0) {
            errors.selectedMethodOfContactError = '*required';
            firstErrorSelector = '[name="contactmethod"]';
            success = false;
        }
        setErrors(errors);
        return { success, errors, firstErrorSelector };
    };
    const validateAccountExtras = () => {
        let errors = {};
        let firstErrorSelector = null;
        let success = true;
        if (fromadminorschool == 2) {
            if (!SchoolProfile?.customer) {
                errors.customerError = '*required';
                firstErrorSelector = '[name="customer"]';
                success = false;
            }
        }
        setErrors(errors);
        return { success, errors, firstErrorSelector };
    };
    const validateDeviceDetails = () => {
        let errors = {};
        let firstErrorSelector = null;
        let success = true;
        if (deviceInformation?.devicesindistrict?.length === 0) {
            errors.deviceDistrictsError = '*required';
            firstErrorSelector = '[name="devicesindistrict"]';
            success = false;
        }
        setErrors(errors);
        return { success, errors, firstErrorSelector };
    };
    const validateRepairDetails = () => {
        let errors = {};
        let firstErrorSelector = null;
        let success = true;

        if (fromadminorschool == 2) {
            if (repairDetails.minRepairGrade == 0 || repairDetails.minRepairGrade == undefined) {
                errors.minRepairGradeError = '*required';
                firstErrorSelector = '[name="minRepairGrade"]';
                success = false;
            }
            if (repairDetails.repairPriceTier == 0 || repairDetails.repairPriceTier == undefined) {
                errors.repairPriceTierError = '*required';
                firstErrorSelector = '[name="repairPriceTier"]';
                success = false;
            }
            if (repairDetails.quotingNeeded == 0 || repairDetails.quotingNeeded == undefined) {
                errors.quotingNeededError = '*required';
                firstErrorSelector = '[name="quotingNeeded"]';
                success = false;
            }
            if (repairDetails.deductible == 0 || repairDetails.deductible == undefined) {
                errors.deductibleError = '*required';
                firstErrorSelector = '[name="deductible"]';
                success = false;
            }
            if (repairDetails.cosmeticDamageRepaird == 0 || repairDetails.cosmeticDamageRepaird == undefined) {
                errors.cosmeticDamageRepairdError = '*required';
                firstErrorSelector = '[name="cosmeticDamageRepaird"]';
                success = false;
            }
            if (repairDetails?.cosmeticDamageRepaird == 1) {
                if (repairDetails?.selectedDamageRepaird?.length === 0) {
                    errors.selectedcosmeticDamageRepairdError = '*required';
                    firstErrorSelector = '[name="cosmeticdamage"]';
                    success = false;
                }
            }
            if (repairDetails.routeDay == 0 || repairDetails.routeDay == undefined) {
                errors.routeDayError = '*required';
                firstErrorSelector = '[name="routeDay"]';
                success = false;
            }
            if (repairDetails.routeFrequency == 0 || repairDetails.routeFrequency == undefined) {
                errors.routeFrequencyError = '*required';
                firstErrorSelector = '[name="routeFrequency"]';
                success = false;
            }
            if (repairDetails.repairCoverage.length === 0) {
                errors.repairCoverageError = '*required';
                firstErrorSelector = '[name="repairCoverage"]';
                success = false;
            }

        }

        if (repairDetails.uncovereddevice == 0 || repairDetails.uncovereddevice == undefined) {
            errors.uncovereddeviceError = '*required';
            firstErrorSelector = '[name="uncovereddevice"]';
            success = false;
        }
        if (loanerAsset?.additionalAssets?.length === 0) {
            errors.assetManagementError = '*required';
            firstErrorSelector = '[name="additionalAssets"]';
            success = false;
        }

        setErrors(errors);
        return { success, errors, firstErrorSelector };
    };
    const validateShippingExtras = () => {
        let errors = {};
        let firstErrorSelector = null;
        let success = true;
        if (mainshippinglocation == 0) {
            if (!shippingDetails?.pickuplocations || shippingDetails?.pickuplocations?.length === 0) {
                errors.pickuplocationError = '*required';
                firstErrorSelector = '[name="pickuplocation"]';
                success = false;
            }
        }
        setErrors(errors);
        return { success, errors, firstErrorSelector };
    };
    const validateBillingExtras = () => {
        let errors = {};
        let firstErrorSelector = null;
        let success = true;
        if (fromadminorschool == 2) {
            if (billingDetails?.accountcreditusage?.length == 0) {
                errors.accountcreditError = '*required';
                firstErrorSelector = '[name="accountcreditusage"]';
                success = false;
            } else if (!SchoolProfile?.pricing) {
                errors.pricingError = '*required';
                firstErrorSelector = '[name="pricing"]';
                success = false;
            }
        }

        setErrors(errors);
        return { success, errors, firstErrorSelector };
    };

    const saveAccountDetailsJson = () => {
        const raw = JSON.stringify({
            Enrollment: SchoolProfile.enrollment || null,
            Customer: SchoolProfile.customer || null,
            SchoolId: fromadminorschool == 2 ? adminSchoolId : LogInSchoolID,
        });
        return raw;
    };
    const saveMainContactDivJson = () => {
        var mainContactjson = {
            Email: contactInformation.email || null,
            FirstName: contactInformation.firstname || null,
            LastName: contactInformation.lastname || null,
            JobTitle: contactInformation.jobtitle || null,
            PhoneNumber: contactInformation.phonenumber || null,
            PhoneType: contactInformation.phonetype || null,
            ContactExtension: contactInformation.contactextension || null,
            MethodOfContact: contactInformation.methodOfContact,
        }
        var secondaryContactjson = {
            Email: secondaryContactInformation.email || null,
            FirstName: secondaryContactInformation.firstname || null,
            LastName: secondaryContactInformation.lastname || null,
            JobTitle: secondaryContactInformation.jobtitle || null,
            PhoneNumber: secondaryContactInformation.phonenumber || null,
            PhoneType: secondaryContactInformation.phonetype || null,
            ContactExtension: secondaryContactInformation.contactextension || null,
            MethodOfContact: secondaryContactInformation.methodOfContact,
        }
        var repairContactjson = {
            Email: repairContactInformation.email || null,
            FirstName: repairContactInformation.firstname || null,
            LastName: repairContactInformation.lastname || null,
            JobTitle: repairContactInformation.jobtitle || null,
            PhoneNumber: repairContactInformation.phonenumber || null,
            PhoneType: repairContactInformation.phonetype || null,
            ContactExtension: repairContactInformation.contactextension || null,
            MethodOfContact: repairContactInformation.methodOfContact,
        }
        const raw = JSON.stringify({
            MainContact: mainContactjson,
            SecondaryContact: showSecondary ? secondaryContactjson : null,
            RepairContact: showRepair ? repairContactjson : null,
            StartDate: k12TechData.startDate ? MMDDYYYY(k12TechData.startDate) : null,
            RelationshipManager: k12TechData.relationShipManager,
            LocationManager: k12TechData.locationManager,
            Driver: k12TechData.driver,
            SchoolId: fromadminorschool == 2 ? adminSchoolId : LogInSchoolID,
        });
        return raw;
    };
    const saveShippingDetailsJson = () => {
        const shippingAddress = {
            FedexCompanyName: shippingDetails.fedex_company_name || null,
            PhoneNum: shippingDetails.Phoneno || null,
            ShippingExtension: shippingDetails.shippingextension || null,
            StreetLine1: shippingDetails.Street1 || null,
            StreetLine2: shippingDetails.Street2 || null,
            City: shippingDetails.city || null,
            State: shippingDetails.state || null,
            PostalCode: shippingDetails.postalcode || null,
            CountryCode: "US",
        };
        const raw = JSON.stringify({
            PickUpLocationArray: shippingDetails.pickuplocations,
            BuildingName: shippingDetails?.pickuplocations?.includes("0") ? shippingDetails.buildingname : null,
            ShippingAddress: shippingAddress,
            MailingAddress: mailingaddress,
            MainShippingLocation: mainshippinglocation,
            SchoolId: fromadminorschool == 2 ? adminSchoolId : LogInSchoolID,
        });
        return raw;
    };
    const saveBillingDetailsJson = () => {
        const billingAddress = {
            StreetLine1: billingDetails.street1,
            StreetLine2: billingDetails.street2 || null,
            City: billingDetails.city,
            State: billingDetails.state,
            PostalCode: billingDetails.postalcode,
            CountryCode: "US",
            PhoneNum: billingDetails.phoneno,
            CompanyName: billingDetails.companyname,
        };
        const billingcontact = {
            FirstName: billingDetails.firstname,
            LastName: billingDetails.lastname,
            Email: billingDetails.email,
            BillingExtension: billingDetails.billingextension || null,
            PhoneNumber: billingDetails.phoneno,

        }
        const raw = JSON.stringify({
            BillingAddress: billingAddress,
            BillingContact: billingcontact,
            AccountCredit: billingDetails.accountcredit || null,
            AccountCreditUsage: billingDetails.accountcreditusage,
            SpecialDiscountsPricing: billingDetails.discoutpricing || null,
            Pricing: SchoolProfile.pricing,
            SchoolId: fromadminorschool == 2 ? adminSchoolId : LogInSchoolID,
        });
        var emailvalid = isValidEmail(billingDetails.email);
        if (emailvalid == false) {
            setEmailValidation("Invalid Email")
            return false;
        } else {
            setEmailValidation("");
        }
        return raw;
    };
    const saveDeviceDetailsDivJson = () => {
        const raw = JSON.stringify({
            SchoolId: fromadminorschool == 2 ? adminSchoolId : LogInSchoolID,
            DeviceInDistrict: deviceInformation.devicesindistrict,
            LoanerDeviceRatio: loanerAsset.countofLoanerDevice,
        });
        return raw;
    }
    const saveRepairDetailsDivJson = () => {
        var repairCoverageArray = [];
        let isError = false;
        {
            if (repairDetails?.repairCoverage?.includes("1")) {
                ASProws?.forEach((item) => {
                    if (item.deviceType && item.carted && item.cases && item.screen && item.deviceModel && item.coverageType && item.startDate && item.endDate) {
                        var vjson = {
                            DeviceType: item.deviceType || null,
                            DeviceModel: item.deviceModel || null,
                            CoverageType: item.coverageType || null,
                            StartDate: item.startDate || null,
                            EndDate: item.endDate || null,
                            Carted: item.carted,
                            Cases: item.cases,
                            Screen: item.screen,
                            ID: 1,
                            Flag: item.id || 0
                        };
                        repairCoverageArray.push(vjson);
                    } else {
                        if (fromadminorschool == 2) {
                            setAsperror(ASProws.length - 1);
                            isError = true;
                        }
                    }

                });
                if (isError) return false;
            }
            if (repairDetails?.repairCoverage?.includes("3")) {
                ADProws?.forEach((item) => {
                    if (item.deviceType && item.cases && item.carted && item.screen && item.deviceModel && item.startDate && item.endDate) {
                        var vjson = {
                            DeviceType: item.deviceType,
                            DeviceModel: item.deviceModel,
                            StartDate: item.startDate,
                            EndDate: item.endDate,
                            Carted: item.carted,
                            Cases: item.cases,
                            Screen: item.screen,
                            ID: 3,
                            Flag: item.id || 0
                        };
                        repairCoverageArray.push(vjson);
                    } else {
                        if (fromadminorschool == 2) {
                            setAdperror(ADProws.length - 1);
                            isError = true;
                        }
                    }
                });
                if (isError) return false;
            }

            if (repairDetails?.repairCoverage?.includes("2")) {
                if (repairCoverageData.adhoc_carted && repairCoverageData.adhoc_cases && repairCoverageData.adhoc_screen) {
                    repairCoverageArray.push({
                        DeviceType: null,
                        DeviceModel: null,
                        CoverageType: null,
                        StartDate: null,
                        EndDate: null,
                        Carted: repairCoverageData.adhoc_carted || 0,
                        Cases: repairCoverageData.adhoc_cases || 0,
                        Screen: repairCoverageData.adhoc_screen || 0,
                        ID: 2,
                        Flag: repairCoverageData.adhoc_id || 0
                    });
                } else {
                    if (fromadminorschool == 2) {
                        setAdhocerror("All fields are required!");
                        isError = true;
                    }
                }
                if (isError) return false;
            }

            if (repairDetails?.repairCoverage?.includes("4")) {
                if (repairCoverageData.parental_carted && repairCoverageData.parental_cases && repairCoverageData.parental_screen) {
                    repairCoverageArray.push({
                        DeviceType: null,
                        DeviceModel: null,
                        CoverageType: null,
                        StartDate: null,
                        EndDate: null,
                        Carted: repairCoverageData.parental_carted || 0,
                        Cases: repairCoverageData.parental_cases || 0,
                        Screen: repairCoverageData.parental_screen || 0,
                        ID: 4,
                        Flag: repairCoverageData.parental_id || 0
                    });
                } else {
                    if (fromadminorschool == 2) {
                        setCoverageerror("All fields are required!");
                        isError = true;
                    }
                }
                if (isError) return false;
            }

        }
        const multiDeviceLogin = logins.map(login => ({
            deviceId: login.id,
            credentials: login.credentials.map(cred => ({
                username: cred.username,
                password: cred.password,
                Flag: cred.flag,
                id: cred.flag == 0 ? 0 : cred.id
            })),
        }));
        const multiDeviceLoginIds = logins.map(login => login.id);
        const repairCapArray = repairCapRows.map(cap => ({
            id: cap.id,
            devicetype: cap.deviceType,
            repaircap: cap.capAmount,
            capexceeding: cap.capexceeding,
            flag: cap.flag,
        }));
        const repairCapIds = repairCapRows.map(cap => cap.id);
        const raw = JSON.stringify({
            SchoolId: fromadminorschool == 2 ? adminSchoolId : LogInSchoolID,
            WeeklyRepairs: deviceInformation.weeklyrepairs,
            RepairCapIds: repairCapIds,
            RepairCapArray: repairCapArray,
            RepairNotes: repairDetails.repairNotes,
            MinimumRepairGrade: repairDetails.minRepairGrade,
            RepairPriceTier: repairDetails.repairPriceTier,
            RepairPriceTierNotes: repairDetails.repairpricetiernotes,
            QuotingNeeded: repairDetails.quotingNeeded,
            Deductible: repairDetails.deductible,
            DeductibleNotes: repairDetails.deductibleNotes,
            CosmeticDamageRepaired: repairDetails.cosmeticDamageRepaird,
            CosmeticDamageRepairedOption: repairDetails.selectedDamageRepaird,
            CosmeticDamageNotes: repairDetails.cosmeticdamageNotes,
            RouteDay: repairDetails.routeDay,
            RouteFrequency: repairDetails.routeFrequency,
            UncoverDeviceRepairActions: repairDetails.uncovereddevice,
            UncoverDeviceRepairNotes: repairDetails.uncovereddeviceNotes || null,
            AdditionalAssetManagementSystem: loanerAsset.additionalAssets,
            AdditionalAssetManagementNotes: repairDetails.additionalAssetNotes || null,
            MultiDeviceLogin: multiDeviceLogin,
            MultiDeviceLoginSelectedArray: multiDeviceLoginIds,
            RepairCoverageID: repairDetails.repairCoverage,
            RepairCoverageArray: repairCoverageArray,
        });
        return raw;
    }
    const handleSaveSection = async (sectionName, validateExtras) => {
        let firstErrorField = null;
        var isFormValid = CheckValidation({ formID: sectionName });
        if (validateExtras) {
            const isValid = validateRequiredFieldsInDiv(sectionName, validateExtras);
            if (!isValid) return;
        }
        const accountDetailsDiv = document.getElementById(sectionName);
        const requiredFields = accountDetailsDiv.querySelectorAll('[required]');
        requiredFields.forEach(field => {
            if (!field.value.trim()) { // Check if field is empty
                field.classList.add('is-invalid'); // Add Bootstrap's invalid class (or your own styling)
                if (!firstErrorField) {
                    firstErrorField = field;
                }
            } else {
                field.classList.remove('is-invalid'); // Remove error styling if field is filled
            }
        });

        if (firstErrorField) {
            firstErrorField.scrollIntoView({ behavior: 'smooth', block: 'center' });
            firstErrorField.focus();
            return;
        }

        if (!isFormValid) return;
        setLoading(true);
        var vJson;
        switch (sectionName) {
            case 'MainContactDiv':
                vJson = saveMainContactDivJson();
                break;
            case 'AccountDetailsDiv':
                vJson = saveAccountDetailsJson();
                break;
            case 'ShippingDetailsDiv':
                vJson = saveShippingDetailsJson();
                break;
            case 'BillingDetailsDiv':
                vJson = saveBillingDetailsJson();
                break;
            case 'DeviceDetailsDiv':
                vJson = saveDeviceDetailsDivJson();
                break;
            case 'RepairDetailsDiv':
                vJson = saveRepairDetailsDivJson();
                break;
            default:
                console.warn('Unknown section');
                break;
        }
        if (vJson == false) {
            setLoading(false);
            return;
        }
        await ApiPostCall("/setSchoolProfileInformation", vJson).then((result) => {
            if (result == undefined || result == "") {
                alert("Something went wrong");
            } else {
                setLoading(false);
                if (result == "success") {
                    setNewAlerts(<AlertsComp show={true} variant="success" msg={"Service Profile Added Successfully."} />);
                    if (fromadminorschool != 2) {
                        if (postImage.myFile == "") {
                            setUserData({ ...UserData, schoollogo: "/images/logo-icon.svg" })
                        } else {
                            setUserData({ ...UserData, schoollogo: postImage.myFile })
                        }
                    }
                    setTimeout(() => {
                        setNewAlerts(<AlertsComp show={false} />);
                        getSchoolProfileInfo();
                    }, 1500);
                }
                else {
                    setNewAlerts(<AlertsComp show={true} variant="danger" msg={result} />);
                }
            }
        });
    }
    const toggleKey = (key) => {
        if (activeKeys.includes(key)) {
            setActiveKeys(activeKeys.filter(k => k !== key));
        } else {
            setActiveKeys([...activeKeys, key]);
        }
    };
    const handleRepairCapChange = (index, field, value) => {
        const updatedRows = [...repairCapRows];
        updatedRows[index][field] = value;
        setRepairCapRows(updatedRows);
    };
    const handleAddRepairCapRow = () => {
        setRepairCapRows([...repairCapRows, { deviceType: "", capAmount: "", capexceeding: "", id: 0, flag: 1 }]);
    };
    const handleRemoveRepairCapRow = (index) => {
        setRepairCapRows((prevRows) => {
            const updatedRows = [...prevRows];
            const row = updatedRows[index];

            if (row.id != 0) {
                updatedRows[index] = { ...row, flag: 3 };
            } else {
                updatedRows.splice(index, 1);
            }

            return updatedRows;
        });
    };
    const popover = (
        <Popover id="popover-basic" style={{ maxWidth: '50%', fontSize: '14px' }} onMouseLeave={() => setShowPopover(false)}>
            <Popover.Header as="h3">Contact Information</Popover.Header>
            <Popover.Body>
                <ul className="text-justify">
                    <li className="pt-1"><label className="fw-600">Email: </label> {k12TechData?.LocationManagerEmail || '-'}</li>
                    <li className="pt-1"><label className="fw-600">Contact Number: </label> {k12TechData?.LocationManagerContact || '-'}</li>
                </ul>
            </Popover.Body>
        </Popover>
    );
    const popoverRelationship = (
        <Popover id="popover-basic" style={{ maxWidth: '50%', fontSize: '14px' }} onMouseLeave={() => setShowPopover(false)}>
            <Popover.Header as="h3">Contact Information</Popover.Header>
            <Popover.Body>
                <ul className="text-justify">
                    <li className="pt-1"><label className="fw-600">Email: </label> {k12TechData?.relationShipManagerEmail || '-'}</li>
                    <li className="pt-1"><label className="fw-600">Contact Number: </label> {k12TechData?.relationShipManagerContact || '-'}</li>
                </ul>
            </Popover.Body>
        </Popover>
    );
    const handleToggle = (nextShow) => {
        setShowPopover(nextShow);
    };
    const handleToggleRelationship = (nextShow) => {
        setRelationshipshowPopover(nextShow);
    };
    const handleToggleAddress = (nextShow) => {
        setShowAddressPopover(nextShow);
    };



    return (
        <div>
            <PageHead heading={"Service Profile"} loading={loading} Alerts={NewAlerts} showsearch={false} />
            <div className="container-fluid px-0 mt-2">
                <div className="GridBox p-2">
                    <div className='greyBox '>

                        {/* main contact information section */}
                        <div>
                            <div className='col-12 pb-2'>
                                <label className='schoolprofile-headers'>Technology Department Main Contact </label>
                            </div>
                            <div className="GridBox  p-2 align-items-center parent" id="MainContactDiv" >
                                <div style={{ border: "1px solid #e2e3e4", borderRadius: "0.3rem" }} className='p-2 mt-3'>
                                    <div className='row '>
                                        <div className="form-check ms-3 form-check-inline">
                                            <input className="form-check-input" disabled defaultChecked type="checkbox" />
                                            <b className="form-check-label" >Main Contact</b>
                                        </div>
                                        <div className="col-xl-4 col-12 pt-3 ">
                                            <div className='col-12 text-start px-1 font-14 pb-1 new-font-style'>Email<label className='redText'>*</label></div>
                                            <select required value={contactInformation.email} name='email'
                                                onChange={(e) => {
                                                    const selectedEmail = e.target.value;
                                                    const selectedStaff = staffEmails.find((item) => item.email == selectedEmail);

                                                    setContactInformation({
                                                        ...contactInformation,
                                                        email: selectedEmail,
                                                        firstname: selectedStaff?.first_name || "",
                                                        lastname: selectedStaff?.last_name || ""
                                                    });
                                                }}>
                                                <option value="0">Select</option>
                                                {staffEmails?.map((item, i) => {
                                                    return <option key={i} value={item.email} defaultChecked={contactInformation.email}>{item.email}</option>
                                                })
                                                }
                                            </select>
                                            <span className="form-text invalid-feedback" >
                                                *required
                                            </span>
                                        </div>
                                        <div className="col-xl-4 col-12 pt-3 ">
                                            <div className='col-12 text-start px-1 font-14 pb-1 new-font-style'>First Name</div>
                                            <input type="text" disabled autoComplete='off' value={contactInformation.firstname} name='firstname' className="form-control" />
                                        </div>
                                        <div className="col-xl-4 col-12 pt-3 ">
                                            <div className='col-12 text-start px-1 font-14 pb-1 new-font-style'>Last Name</div>
                                            <input type="text" disabled autoComplete='off' value={contactInformation.lastname} name='lastname' className="form-control" />
                                        </div>
                                        <div className="col-xl-4 col-12 pt-3 ">
                                            <div className='col-12 text-start px-1 font-14 pb-1 new-font-style'>Job Title<label className='redText'>*</label></div>
                                            <input type="text" autoComplete='off' name='jobtitle' className="form-control" required
                                                value={contactInformation.jobtitle} onChange={(e) => setContactInformation({ ...contactInformation, jobtitle: e.target.value })} />
                                            <span className="form-text invalid-feedback" >
                                                *required
                                            </span>
                                        </div>

                                        <div className="col-xl-3 pe-0 col-12 pt-3 ">
                                            <div className='col-12 text-start px-1 font-14 pb-1 new-font-style'>Phone Number<label className=' redText'>*</label></div>
                                            <input type="text" autoComplete='off' name='phonenumber' className="form-control" required
                                                value={contactInformation.phonenumber}
                                                onChange={(e) => {
                                                    const onlyNumbers = e.target.value.replace(/\D/g, ''); // Remove all non-digit characters
                                                    setContactInformation({ ...contactInformation, phonenumber: onlyNumbers });
                                                }} />
                                            <span className="form-text invalid-feedback" >
                                                *required
                                            </span>
                                        </div>
                                        <div className="col-xl-1 col-12 pt-3 ps-0">
                                            <div className='col-12 text-start px-1 font-14 pb-1 new-font-style'>Ext</div>
                                            <input type="text" autoComplete='off' name='billingextension' className="form-control"
                                                value={contactInformation.contactextension}
                                                onChange={(e) => {
                                                    const onlyNumbers = e.target.value.replace(/\D/g, ''); // Remove all non-digit characters
                                                    setContactInformation({ ...contactInformation, contactextension: onlyNumbers });
                                                }}
                                            />
                                        </div>
                                        <div className="col-xl-4 col-12 pt-3 ">
                                            <div className='col-12 text-start px-1 font-14 pb-1 new-font-style'>Phone Type<label className='redText'>*</label></div>
                                            <select required name='phonetype' value={contactInformation.phonetype} onChange={(e) => setContactInformation({ ...contactInformation, phonetype: e.target.value })}>
                                                <option value="0">Select</option>
                                                <option value="1">Work</option>
                                                <option value="2">Mobile</option>
                                                <option value="3">Other</option>
                                            </select>
                                            <span className="form-text invalid-feedback" >
                                                *required
                                            </span>
                                        </div>
                                        <div className="col-xl-8 col-12 pt-3 ">
                                            <div style={{ border: "1px solid #e2e3e4", borderRadius: "0.3rem" }} className='p-2 h-100'>
                                                <div className='col-12 text-start px-1 new-font-style'>Preferred Method Of Contact<label className='redText'>*</label></div>
                                                <div className='col-md-12 font-13 ps-3 d-flex'>
                                                    {methodOfContact.map((contact, index) => (
                                                        <div className="font-13 ps-3 d-flex align-items-center" key={index}>
                                                            <input
                                                                id={`contactmethod-${contact.id}`}
                                                                className="form-check-input mt-1 me-2 cursor-pointer"
                                                                type="checkbox"
                                                                name='contactmethod'
                                                                aria-label={contact.id}
                                                                checked={contactInformation?.methodOfContact?.includes(String(contact.id)) || false}
                                                                onChange={(e) => handleMethodOfContactCheckboxChange(e, contact.id)}
                                                            />
                                                            <label htmlFor={`contactmethod-${contact.id}`}
                                                                className={`form-check-label ${contactInformation?.methodOfContact?.includes(String(contact.id)) ? 'fw-bold' : ''
                                                                    }`}>
                                                                {contact.name}
                                                            </label>
                                                        </div>
                                                    ))}
                                                </div>
                                                <span className="Emailinvalid" >
                                                    {errors.selectedMethodOfContactError}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div style={{ border: "1px solid #e2e3e4", borderRadius: "0.3rem" }} className='p-2 mt-3'>
                                    <div className="form-check form-check-inline">
                                        <input className="form-check-input" type="checkbox" id="toggleSecondary" checked={showSecondary} onChange={() => setShowSecondary(!showSecondary)} />
                                        <b className="form-check-label" htmlFor="toggleSecondary">Add Secondary Contact</b>
                                    </div>
                                    {showSecondary && (
                                        <div className='row '>
                                            <div className="col-xl-4 col-12 pt-3 ">
                                                <div className='col-12 text-start px-1 font-14 pb-1 new-font-style'>Email</div>
                                                <select value={secondaryContactInformation.email} name='email'
                                                    onChange={(e) => {
                                                        const selectedEmail = e.target.value;
                                                        const selectedStaff = staffEmails.find((item) => item.email == selectedEmail);

                                                        setSecondaryContactInformation({
                                                            ...secondaryContactInformation,
                                                            email: selectedEmail,
                                                            firstname: selectedStaff?.first_name || "",
                                                            lastname: selectedStaff?.last_name || ""
                                                        });
                                                    }}>
                                                    <option value="0">Select</option>
                                                    {staffEmails?.map((item, i) => {
                                                        return <option key={i} value={item.email}>{item.email}</option>
                                                    })
                                                    }
                                                </select>

                                            </div>
                                            <div className="col-xl-4 col-12 pt-3 ">
                                                <div className='col-12 text-start px-1 font-14 pb-1 new-font-style'>First Name</div>
                                                <input type="text" disabled autoComplete='off' value={secondaryContactInformation.firstname} name='firstname' className="form-control" />
                                            </div>
                                            <div className="col-xl-4 col-12 pt-3 ">
                                                <div className='col-12 text-start px-1 font-14 pb-1 new-font-style'>Last Name</div>
                                                <input type="text" disabled autoComplete='off' value={secondaryContactInformation.lastname} name='lastname' className="form-control" />
                                            </div>
                                            <div className="col-xl-4 col-12 pt-3 ">
                                                <div className='col-12 text-start px-1 font-14 pb-1 new-font-style'>Job Title</div>
                                                <input type="text" autoComplete='off' name='jobtitle' className="form-control"
                                                    value={secondaryContactInformation.jobtitle} onChange={(e) => setSecondaryContactInformation({ ...secondaryContactInformation, jobtitle: e.target.value })} />

                                            </div>
                                            <div className="col-xl-3 pe-0 col-12 pt-3 ">
                                                <div className='col-12 text-start px-1 font-14 pb-1 new-font-style'>Phone Number</div>
                                                <input type="text" autoComplete='off' name='phonenumber' className="form-control"
                                                    value={secondaryContactInformation.phonenumber}
                                                    onChange={(e) => {
                                                        const onlyNumbers = e.target.value.replace(/\D/g, ''); // Remove all non-digit characters
                                                        setSecondaryContactInformation({ ...secondaryContactInformation, phonenumber: onlyNumbers });
                                                    }} />

                                            </div>
                                            <div className="col-xl-1 col-12 pt-3 ps-0">
                                                <div className='col-12 text-start px-1 font-14 pb-1 new-font-style'>Ext</div>
                                                <input type="text" autoComplete='off' name='billingextension' className="form-control"
                                                    value={secondaryContactInformation.contactextension}
                                                    onChange={(e) => {
                                                        const onlyNumbers = e.target.value.replace(/\D/g, ''); // Remove all non-digit characters
                                                        setSecondaryContactInformation({ ...secondaryContactInformation, contactextension: onlyNumbers });
                                                    }} />

                                            </div>
                                            <div className="col-xl-4 col-12 pt-3 ">
                                                <div className='col-12 text-start px-1 font-14 pb-1 new-font-style'>Phone Type</div>
                                                <select name='phonetype' value={secondaryContactInformation.phonetype} onChange={(e) => setSecondaryContactInformation({ ...secondaryContactInformation, phonetype: e.target.value })}>
                                                    <option value="0">Select</option>
                                                    <option value="1">Work</option>
                                                    <option value="2">Mobile</option>
                                                    <option value="3">Other</option>
                                                </select>

                                            </div>
                                            <div className="col-xl-8 col-12 pt-3 ">
                                                <div style={{ border: "1px solid #e2e3e4", borderRadius: "0.3rem" }} className='p-2 h-100'>
                                                    <div className='col-12 text-start px-1 new-font-style'>Preferred Method Of Contact</div>
                                                    <div className='col-md-12 font-13 ps-3 d-flex'>
                                                        {methodOfContact.map((contact, index) => (
                                                            <div className="font-13 ps-3 d-flex align-items-center" key={index}>
                                                                <input
                                                                    id={`secondarycontactmethod-${contact.id}`}
                                                                    className="form-check-input mt-1 me-2 cursor-pointer"
                                                                    type="checkbox"
                                                                    name='secondarycontactmethod'
                                                                    aria-label={contact.id}
                                                                    checked={secondaryContactInformation?.methodOfContact?.includes(String(contact.id)) || false}
                                                                    onChange={(e) => handleMethodOfSecondaryContactCheckboxChange(e, contact.id)}
                                                                />
                                                                <label htmlFor={`secondarycontactmethod-${contact.id}`}
                                                                    className={`form-check-label ${secondaryContactInformation?.methodOfContact?.includes(String(contact.id)) ? 'fw-bold' : ''
                                                                        }`}>
                                                                    {contact.name}
                                                                </label>
                                                            </div>
                                                        ))}
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </div>
                                <div style={{ border: "1px solid #e2e3e4", borderRadius: "0.3rem" }} className='p-2 mt-3'>
                                    <div className="form-check form-check-inline ">
                                        <input className="form-check-input" type="checkbox" id="toggleRepair" checked={showRepair} onChange={() => setShowRepair(!showRepair)} />
                                        <b className="form-check-label" htmlFor="toggleRepair">Add Repair Contact</b>
                                    </div>
                                    {showRepair && (
                                        <div className='row '>
                                            <div className="col-xl-4 col-12 pt-3 ">
                                                <div className='col-12 text-start px-1 font-14 pb-1 new-font-style'>Email</div>
                                                <select value={repairContactInformation.email} name='email'
                                                    onChange={(e) => {
                                                        const selectedEmail = e.target.value;
                                                        const selectedStaff = staffEmails.find((item) => item.email == selectedEmail);

                                                        setRepairContactInformation({
                                                            ...repairContactInformation,
                                                            email: selectedEmail,
                                                            firstname: selectedStaff?.first_name || "",
                                                            lastname: selectedStaff?.last_name || ""
                                                        });
                                                    }}>
                                                    <option value="0">Select</option>
                                                    {staffEmails?.map((item, i) => {
                                                        return <option key={i} value={item.email}>{item.email}</option>
                                                    })
                                                    }
                                                </select>

                                            </div>
                                            <div className="col-xl-4 col-12 pt-3 ">
                                                <div className='col-12 text-start px-1 font-14 pb-1 new-font-style'>First Name</div>
                                                <input type="text" disabled autoComplete='off' value={repairContactInformation.firstname} name='firstname' className="form-control" />
                                            </div>
                                            <div className="col-xl-4 col-12 pt-3 ">
                                                <div className='col-12 text-start px-1 font-14 pb-1 new-font-style'>Last Name</div>
                                                <input type="text" disabled autoComplete='off' value={repairContactInformation.lastname} name='lastname' className="form-control" />
                                            </div>
                                            <div className="col-xl-4 col-12 pt-3 ">
                                                <div className='col-12 text-start px-1 font-14 pb-1 new-font-style'>Job Title</div>
                                                <input type="text" autoComplete='off' name='jobtitle' className="form-control"
                                                    value={repairContactInformation.jobtitle} onChange={(e) => setRepairContactInformation({ ...repairContactInformation, jobtitle: e.target.value })} />

                                            </div>
                                            <div className="col-xl-3 pe-0 col-12 pt-3 ">
                                                <div className='col-12 text-start px-1 font-14 pb-1 new-font-style'>Phone Number</div>
                                                <input type="text" autoComplete='off' name='phonenumber' className="form-control"
                                                    value={repairContactInformation.phonenumber}
                                                    onChange={(e) => {
                                                        const onlyNumbers = e.target.value.replace(/\D/g, ''); // Remove all non-digit characters
                                                        setRepairContactInformation({ ...repairContactInformation, phonenumber: onlyNumbers });
                                                    }} />

                                            </div>
                                            <div className="col-xl-1 col-12 pt-3 ps-0">
                                                <div className='col-12 text-start px-1 font-14 pb-1 new-font-style'>Ext</div>
                                                <input type="text" autoComplete='off' name='billingextension' className="form-control"
                                                    value={repairContactInformation.contactextension}
                                                    onChange={(e) => {
                                                        const onlyNumbers = e.target.value.replace(/\D/g, ''); // Remove all non-digit characters
                                                        setRepairContactInformation({ ...repairContactInformation, contactextension: onlyNumbers });
                                                    }} />

                                            </div>
                                            <div className="col-xl-4 col-12 pt-3 ">
                                                <div className='col-12 text-start px-1 font-14 pb-1 new-font-style'>Phone Type</div>
                                                <select name='phonetype' value={repairContactInformation.phonetype} onChange={(e) => setRepairContactInformation({ ...repairContactInformation, phonetype: e.target.value })}>
                                                    <option value="0">Select</option>
                                                    <option value="1">Work</option>
                                                    <option value="2">Mobile</option>
                                                    <option value="3">Other</option>
                                                </select>

                                            </div>
                                            <div className="col-xl-8  col-12 pt-3 ">
                                                <div style={{ border: "1px solid #e2e3e4", borderRadius: "0.3rem" }} className='p-2 h-100'>
                                                    <div className='col-12 text-start px-1 new-font-style'>Preferred Method Of Contact</div>
                                                    <div className='col-md-12 font-13 ps-3 d-flex'>
                                                        {methodOfContact.map((contact, index) => (
                                                            <div className="font-13 ps-3 d-flex align-items-center" key={index}>
                                                                <input
                                                                    id={`repaircontactmethod-${contact.id}`}
                                                                    className="form-check-input mt-1 me-2 cursor-pointer"
                                                                    type="checkbox"
                                                                    name='repaircontactmethod'
                                                                    aria-label={contact.id}
                                                                    checked={repairContactInformation?.methodOfContact?.includes(String(contact.id)) || false}
                                                                    onChange={(e) => handleMethodOfRepairContactCheckboxChange(e, contact.id)}
                                                                />
                                                                <label htmlFor={`repaircontactmethod-${contact.id}`}
                                                                    className={`form-check-label ${repairContactInformation?.methodOfContact?.includes(String(contact.id)) ? 'fw-bold' : ''
                                                                        }`}>
                                                                    {contact.name}
                                                                </label>
                                                            </div>
                                                        ))}
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </div>
                                <hr />
                                {/* k-12 tech details */}
                                <div className=''>
                                    <div className='col-12  pb-2'>
                                        <label className='schoolprofile-headers'>Your K-12 Tech Team</label>
                                    </div>
                                    <div className='col-12 px-3'>
                                        <div className='row ' style={{ backgroundColor: fromadminorschool != 2 && "rgb(240, 240, 241)", border: fromadminorschool != 2 && "1px solid rgb(226, 227, 228)", borderRadius: fromadminorschool != 2 && "0.3rem" }}>
                                            <div className="col-xl-4 col-12 pt-3 ">
                                                <div className='col-12 text-start font-13 px-1 pb-1 new-font-style'>Start Date</div>
                                                <input
                                                    type="date"
                                                    className="form-control"
                                                    value={k12TechData.startDate}
                                                    onChange={(e) => setK12TechData({ ...k12TechData, startDate: e.target.value })}
                                                    disabled={fromadminorschool != 2}
                                                />
                                            </div>
                                            <div className="col-xl-4 col-12 pt-3">
                                                <div className='col-12 text-start font-13  pb-1 new-font-style'>Relationship Manager{fromadminorschool == 2 && <label className='redText'>*</label>}</div>
                                                <div className='row pe-2'>
                                                    {fromadminorschool != 2 ?
                                                        <div className='col-md-10 pe-0'>
                                                            <select name='relationshipmanager' style={{ backgroundColor: fromadminorschool != 2 && "#e9ecef" }} disabled={fromadminorschool != 2} value={k12TechData.relationShipManager} onChange={(e) => setK12TechData({ ...k12TechData, relationShipManager: e.target.value })}>
                                                                <option value="0">Select</option>
                                                                {allk12Admins?.map((item, i) => {
                                                                    return <option key={i} value={item.id}>{item.first_name} {item.last_name} {item.phone_number && `(${item.phone_number})`}</option>
                                                                })}
                                                            </select>
                                                        </div>
                                                        :
                                                        <>
                                                            <select required name='relationshipmanager' style={{ backgroundColor: fromadminorschool != 2 && "#e9ecef" }} disabled={fromadminorschool != 2} value={k12TechData.relationShipManager} onChange={(e) => setK12TechData({ ...k12TechData, relationShipManager: e.target.value })}>
                                                                <option value="0">Select</option>
                                                                {allk12Admins?.map((item, i) => {
                                                                    return <option key={i} value={item.id}>{item.first_name} {item.last_name} {item.phone_number && `(${item.phone_number})`}</option>
                                                                })}
                                                            </select>
                                                            <span className="form-text invalid-feedback" >
                                                                *required
                                                            </span>
                                                        </>
                                                    }
                                                    {fromadminorschool != 2 &&
                                                        <div className='col-md-2'>
                                                            <OverlayTrigger
                                                                trigger="click"
                                                                show={relationshipshowPopover}
                                                                onToggle={handleToggleRelationship}
                                                                overlay={popoverRelationship}
                                                            >
                                                                <a href="#" role="button">
                                                                    <img src="/images/InfoBtn.svg" title="Show Email and Contact Number" className="cursor-pointer" height='16px' />
                                                                </a>
                                                            </OverlayTrigger>
                                                        </div>
                                                    }
                                                </div>
                                            </div>
                                            <div className="col-xl-4 col-12 pt-3 ">
                                                <div className='col-12 text-start font-13 pb-1 new-font-style'>Location Manager{fromadminorschool == 2 && <label className='redText'>*</label>}</div>
                                                <div className='row pe-2'>
                                                    {fromadminorschool != 2 ?
                                                        <div className='col-md-10 pe-0'>
                                                            <select name='locationmanager'
                                                                style={{ backgroundColor: fromadminorschool != 2 && "#e9ecef" }}
                                                                disabled={fromadminorschool != 2} value={k12TechData.locationManager}
                                                                onChange={(e) => setK12TechData({ ...k12TechData, locationManager: e.target.value })}>
                                                                <option value="0">Select</option>
                                                                {allk12Admins?.map((item, i) => {
                                                                    return <option key={i} value={item.id}>{item.first_name} {item.last_name}{item.phone_number && `(${item.phone_number})`}</option>
                                                                })}
                                                            </select>
                                                        </div>
                                                        :
                                                        <>
                                                            <select required name='locationmanager'
                                                                style={{ backgroundColor: fromadminorschool != 2 && "#e9ecef" }}
                                                                disabled={fromadminorschool != 2} value={k12TechData.locationManager}
                                                                onChange={(e) => setK12TechData({ ...k12TechData, locationManager: e.target.value })}>
                                                                <option value="0">Select</option>
                                                                {allk12Admins?.map((item, i) => {
                                                                    return <option key={i} value={item.id}>{item.first_name} {item.last_name}{item.phone_number && `(${item.phone_number})`}</option>
                                                                })}
                                                            </select>
                                                            <span className="form-text invalid-feedback" >
                                                                *required
                                                            </span>
                                                        </>
                                                    }

                                                    {fromadminorschool != 2 &&
                                                        <div className='col-md-2'>
                                                            <OverlayTrigger
                                                                trigger="click"
                                                                show={showPopover}
                                                                onToggle={handleToggle}
                                                                overlay={popover}
                                                            >
                                                                <a href="#" role="button">
                                                                    <img src="/images/InfoBtn.svg" title="Show Email and Contact Number" className="cursor-pointer" height='16px' />
                                                                </a>
                                                            </OverlayTrigger>
                                                        </div>
                                                    }
                                                </div>
                                            </div>
                                            <div className="col-xl-4 col-12 py-3 ">
                                                <div className='col-12 text-start font-13 px-1 pb-1 new-font-style'>Driver{fromadminorschool == 2 && <label className='redText'>*</label>}</div>
                                                <select required name='driver' style={{ backgroundColor: fromadminorschool != 2 && "#e9ecef" }} disabled={fromadminorschool != 2} value={k12TechData.driver} onChange={(e) => setK12TechData({ ...k12TechData, driver: e.target.value })}>
                                                    <option value="0">Select</option>
                                                    {allTechnicians?.map((item, i) => {
                                                        return <option key={i} value={item.id}>{item.first_name} {item.last_name}</option>
                                                    })}
                                                </select>
                                                <span className="form-text invalid-feedback" >
                                                    *required
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-12 text-end py-3">
                                    <button className="SaveBtn" onClick={(e) => handleSaveSection('MainContactDiv', validateMainContactExtras)}>Save Contact Information</button>
                                    <label className="ms-4 cursor-pointer" onClick={(e) => { fromadminorschool == 2 ? navigate("/schools") : navigate("/dashboard") }}><u>Exit</u></label>
                                </div>
                            </div>
                        </div>


                        {/* account information section */}
                        {fromadminorschool == 2 && (
                            <div className='pt-3'>
                                <div className='col-12  pb-2'>
                                    <label className='schoolprofile-headers'>Account Information</label>
                                </div>
                                <div className="GridBox p-2 align-items-center parent" id='AccountDetailsDiv' >
                                    <div className='row'>
                                        <div className="col-xl-4 col-12 pt-3">
                                            <div style={{ border: "1px solid #e2e3e4", borderRadius: "0.3rem" }} className='p-2 h-100'>
                                                <div className='col-12 text-start px-1 pb-1 new-font-style'>Customer<label className='redText'>*</label></div>
                                                <div className='col-md-12 font-13 ps-3'>
                                                    <div className="form-check">
                                                        <input
                                                            className="form-check-input"
                                                            type="radio"
                                                            name='customer'
                                                            checked={SchoolProfile.customer == 1}
                                                            onChange={(e) => setSchoolProfile({ ...SchoolProfile, customer: 1 })}
                                                        />
                                                        <label className={`form-check-label ${SchoolProfile.customer == 1 ? 'fw-bold' : ''}`}>Yes</label>
                                                    </div>
                                                    <div className="form-check">
                                                        <input
                                                            className="form-check-input"
                                                            type="radio"
                                                            name='customer'
                                                            checked={SchoolProfile.customer == 2}
                                                            onChange={(e) => setSchoolProfile({ ...SchoolProfile, customer: 2 })}
                                                        />
                                                        <label className={`form-check-label ${SchoolProfile.customer == 2 ? 'fw-bold' : ''}`}>No</label>
                                                    </div>
                                                </div>
                                                <span className="Emailinvalid" >
                                                    {errors.customerError}
                                                </span>
                                            </div>
                                        </div>
                                        <div className="col-xl-4 col-12 pt-3 ">
                                            <div className='col-12 text-start px-1 font-14 pb-1 new-font-style'>Enrollment<label className='redText'>*</label></div>
                                            <input type="text" autoComplete='off' name='enrollment' className="form-control"
                                                required value={SchoolProfile.enrollment}
                                                onChange={(e) => {
                                                    const onlyNumbers = e.target.value.replace(/\D/g, ''); // Remove all non-digit characters
                                                    setSchoolProfile({ ...SchoolProfile, enrollment: onlyNumbers });
                                                }} />
                                            <span className="form-text invalid-feedback" >
                                                *required
                                            </span>
                                        </div>
                                    </div>
                                    <div className="col-12 text-end py-3">
                                        <button className="SaveBtn" onClick={(e) => handleSaveSection('AccountDetailsDiv', validateAccountExtras)}>Save Account Information</button>
                                        <label className="ms-4 cursor-pointer" onClick={(e) => { fromadminorschool == 2 ? navigate("/schools") : navigate("/dashboard") }}><u>Exit</u></label>
                                    </div>
                                </div>
                            </div>
                        )}

                        {/* shipping details section */}
                        <div className='pt-3'>
                            <div className='col-12 pb-2'>
                                <label className='schoolprofile-headers'>Shipping Information</label>
                            </div>
                            <div className="GridBox p-2 align-items-center parent" id='ShippingDetailsDiv' >
                                <div className='row'>
                                    <div className="col-xl-4 col-12 pt-3 ">
                                        <div className='col-12 text-start px-1 font-14 pb-1 new-font-style'>
                                            Shipping - Company/School Name<label className='redText'>*</label></div>
                                        <input type="text" autoComplete='off' name='fedex_company_name'
                                            className="form-control" required value={shippingDetails.fedex_company_name}
                                            onChange={(e) => setShippingDetails({ ...shippingDetails, fedex_company_name: e.target.value })}
                                        />
                                        <span className="form-text invalid-feedback" >
                                            *required
                                        </span>
                                    </div>
                                    <div className="col-xl-3 col-12 pe-0 pt-3">
                                        <div className='col-12 text-start px-1 font-14 pb-1 new-font-style'>Phone Number<label className='redText'>*</label></div>
                                        <input type="text" autoComplete='off' name='Phoneno' className="form-control" required
                                            value={shippingDetails.Phoneno}

                                            onChange={(e) => {
                                                const onlyNumbers = e.target.value.replace(/\D/g, ''); // Remove all non-digit characters
                                                setShippingDetails({ ...shippingDetails, Phoneno: onlyNumbers });
                                            }}
                                        />
                                        <span className="form-text invalid-feedback" >
                                            *required
                                        </span>
                                    </div>
                                    <div className="col-xl-1 col-12 pt-3 ps-0">
                                        <div className='col-12 text-start px-1 font-14 pb-1 new-font-style'>Ext</div>
                                        <input type="text" autoComplete='off' name='shippingextension' className="form-control"
                                            value={shippingDetails.shippingextension}
                                            onChange={(e) => {
                                                const onlyNumbers = e.target.value.replace(/\D/g, ''); // Remove all non-digit characters
                                                setShippingDetails({ ...shippingDetails, shippingextension: onlyNumbers });
                                            }}

                                        />
                                        <span className="form-text invalid-feedback" >
                                            *required
                                        </span>
                                    </div>
                                    <div className="col-xl-4 col-12 pt-3">
                                        <div className='col-12 text-start px-1 font-14 pb-1 new-font-style'>Street Line 1<label className='redText'>*</label></div>
                                        <input type="text" autoComplete='off' name='Street1' className="form-control" required
                                            value={shippingDetails.Street1} onChange={(e) => setShippingDetails({ ...shippingDetails, Street1: e.target.value })}
                                        />
                                        <span className="form-text invalid-feedback" >
                                            *required
                                        </span>
                                    </div>
                                    <div className="col-xl-4 col-12 pt-3">
                                        <div className='col-12 text-start px-1 font-13 pb-1 new-font-style'>Street Line 2</div>
                                        <input type="text" autoComplete='off' name='Street2' className="form-control"
                                            value={shippingDetails.Street2} onChange={(e) => setShippingDetails({ ...shippingDetails, Street2: e.target.value })}
                                        />
                                    </div>
                                    <div className="col-xl-4 col-12 pt-3">
                                        <div className='col-12 text-start px-1 font-14 pb-1 new-font-style'>City<label className='redText'>*</label></div>
                                        <input type="text" autoComplete='off' name='city' className="form-control" required
                                            value={shippingDetails.city}
                                            onChange={(e) => {
                                                const newCity = e.target.value;
                                                setShippingDetails(prev => ({ ...prev, city: newCity }));

                                                if (!billingCityTouched) {
                                                    setBillingDetails(prev => ({ ...prev, city: newCity }));
                                                }
                                            }}
                                        />
                                        <span className="form-text invalid-feedback" >
                                            *required
                                        </span>
                                    </div>
                                    <div className="col-xl-4 col-12 pt-3">
                                        <div className='col-12 text-start px-1 font-14 pb-1 new-font-style'>State<label className='redText'>*</label></div>
                                        <select required name='state' value={shippingDetails.state}
                                            onChange={(e) => {
                                                const newState = e.target.value;
                                                setShippingDetails(prev => ({ ...prev, state: newState }));

                                                if (!billingStateTouched) {
                                                    setBillingDetails(prev => ({ ...prev, state: newState }));
                                                }
                                            }}>
                                            <option value="0">Select</option>
                                            {AllState.map((item, i) => {
                                                return <option key={i} value={item.state_code}>{item.state_code}</option>
                                            })}
                                        </select>
                                        <span className="form-text invalid-feedback" >
                                            *required
                                        </span>
                                    </div>
                                    <div className="col-xl-4 col-12 pt-3">
                                        <div className='col-12 text-start px-1 font-14 pb-1 new-font-style'>Zip Code<label className='redText'>*</label></div>
                                        <input type="number" required autoComplete='off' name='postalcode' className="form-control"
                                            value={shippingDetails.postalcode}
                                            onChange={(e) => {
                                                const newPostalCode = e.target.value;
                                                setShippingDetails(prev => ({ ...prev, postalcode: newPostalCode }));

                                                if (!billingZipTouched) {
                                                    setBillingDetails(prev => ({ ...prev, postalcode: newPostalCode }));
                                                }
                                            }}
                                        />
                                        <span className="form-text invalid-feedback" >
                                            *required
                                        </span>
                                    </div>
                                    <div className='col-xl-4 col-12 pt-5'>
                                        <input
                                            id={`mailingaddress`}
                                            className="form-check-input mt-1 me-2 cursor-pointer"
                                            type="checkbox"
                                            name='pickuplocation'
                                            checked={mailingaddress == 1}
                                            onChange={(e) => {
                                                const isChecked = e.target.checked;
                                                setMailingAddress(isChecked ? 1 : 0);
                                            }}
                                        />
                                        <label htmlFor={`mailingaddress`}
                                            className={`form-check-label ${mailingaddress == 1 ? 'fw-bold' : ''}`}>
                                            Mailing / Promotional Address
                                        </label>
                                        <OverlayTrigger
                                            trigger="click"
                                            show={showAddressPopover}
                                            onToggle={handleToggleAddress}
                                            overlay={
                                                <Popover style={{ maxWidth: '50%', fontSize: '14px' }} onMouseLeave={() => setShowAddressPopover(false)}>
                                                    <Popover.Body>
                                                        Items coming from K-12 Tech could be anything from case samples, thank you cards, or other materials K-12 Tech sends out throughout the year.
                                                    </Popover.Body>
                                                </Popover>
                                            }
                                        >
                                            <a href="#" role="button">
                                                <img src="/images/InfoBtn.svg" title="Show Email and Contact Number" className="ps-2 cursor-pointer" height='16px' />
                                            </a>
                                        </OverlayTrigger>
                                    </div>
                                    <div className='col-xl-4 col-12 pt-5'>
                                        <input
                                            id={`mainshippinglocation`}
                                            className="form-check-input mt-1 me-2 cursor-pointer"
                                            type="checkbox"
                                            name='pickuplocation'
                                            checked={mainshippinglocation == 1}
                                            onChange={(e) => {
                                                const isChecked = e.target.checked;
                                                setMainShippingLocation(isChecked ? 1 : 0);
                                            }}
                                        />
                                        <label htmlFor={`mainshippinglocation`}
                                            className={`form-check-label ${mainshippinglocation == 1 ? 'fw-bold' : ''}`}>
                                            Main Device Shipping Location
                                        </label>
                                    </div>

                                    <div className="col-12 col-12 pt-3 ">
                                        <div style={{ border: "1px solid #e2e3e4", borderRadius: "0.3rem" }} className='p-2 h-100'>
                                            <div className='col-12 text-start px-1 pb-1 new-font-style'>{ShippingType == 1 ? 'Local Pick-Up/Dropoff Location(s)' : 'Alternate Delivery Locations'}{mainshippinglocation == 0 && <label className='redText'>*</label>}</div>
                                            <div className='col-md-12 row font-13 ps-3 pt-3'>
                                                {allPickUpLocations?.map((account, index) => {
                                                    const idString = account.id;
                                                    const isChecked = shippingDetails?.pickuplocations?.includes(idString);
                                                    return (
                                                        <div className="col-md-3 font-13 d-flex align-items-center" key={index}>
                                                            <input
                                                                id={`pickuplocation-${account.id}`}
                                                                className="form-check-input mt-1 me-2 cursor-pointer"
                                                                type="checkbox"
                                                                name='pickuplocation'
                                                                aria-label={account.id}
                                                                checked={isChecked}
                                                                onChange={(e) => {
                                                                    const updated = [...(shippingDetails.pickuplocations || [])];
                                                                    if (e.target.checked) {
                                                                        if (!updated.includes(idString)) updated.push(idString);
                                                                    } else {
                                                                        const indexToRemove = updated.indexOf(idString);
                                                                        if (indexToRemove > -1) updated.splice(indexToRemove, 1);
                                                                    }
                                                                    setShippingDetails({ ...shippingDetails, pickuplocations: updated });
                                                                }}
                                                            />
                                                            <label htmlFor={`pickuplocation-${account.id}`}
                                                                className={`form-check-label ${isChecked ? 'fw-bold' : ''}`}>
                                                                {account.name}
                                                            </label>
                                                            <img src='/images/EditIconNew.svg' title="Show Address" className="cursor-pointer ps-2"
                                                                onClick={() => { setBuildingAddressPopup(true); setSelectedBuildingAddress(account) }} />
                                                        </div>
                                                    )
                                                })}
                                                <div className="col-md-3 font-13 d-flex align-items-center">
                                                    <input
                                                        id={`pickuplocation-0`}
                                                        className="form-check-input mt-1 me-2 cursor-pointer"
                                                        type="checkbox"
                                                        name='pickuplocation'
                                                        checked={shippingDetails?.pickuplocations?.includes("0")}
                                                        onChange={(e) => {
                                                            const updated = [...(shippingDetails.pickuplocations || [])];
                                                            if (e.target.checked) {
                                                                if (!updated.includes("0")) updated.push("0");
                                                            } else {
                                                                const indexToRemove = updated.indexOf("0");
                                                                if (indexToRemove > -1) updated.splice(indexToRemove, 1);
                                                                setShippingDetails(prev => ({ ...prev, buildingname: "" }));
                                                            }
                                                            setShippingDetails({ ...shippingDetails, pickuplocations: updated });
                                                        }}
                                                    />
                                                    <label className={`form-check-label ${shippingDetails?.pickuplocations?.includes("0") ? 'fw-bold' : ''}`}>
                                                        Other
                                                    </label>
                                                </div>
                                            </div>
                                            <span className="Emailinvalid" >
                                                {errors.pickuplocationError}
                                            </span>
                                            {shippingDetails?.pickuplocations?.includes("0") && (
                                                <div className="col-xl-4 col-12 pt-3 ">
                                                    <div className='col-12 text-start px-1 font-13 pb-1 new-font-style'>Enter Building<label className='redText'>*</label></div>
                                                    <input type="text" autoComplete='off' name='buildingname' className="form-control" required
                                                        value={shippingDetails.buildingname || ""} onChange={(e) => setShippingDetails({ ...shippingDetails, buildingname: e.target.value })} />
                                                    <span className="form-text invalid-feedback" >
                                                        *required
                                                    </span>
                                                </div>
                                            )}
                                        </div>

                                    </div>

                                </div>
                                <div className="col-12 text-end py-3">
                                    <button className="SaveBtn" onClick={(e) => handleSaveSection('ShippingDetailsDiv', validateShippingExtras)}>Save Shipping Information</button>
                                    <label className="ms-4 cursor-pointer" onClick={(e) => { fromadminorschool == 2 ? navigate("/schools") : navigate("/dashboard") }}><u>Exit</u></label>
                                </div>
                            </div>
                        </div>

                        {/* billing details section */}
                        <div className='pt-3'>
                            <div className='col-12 pb-2'>
                                <label className='schoolprofile-headers'>Billing Information</label>
                            </div>
                            <div className="GridBox p-2 align-items-center parent" id='BillingDetailsDiv' >
                                <div className='row '>
                                    <div className='col-12'>
                                        <input
                                            className="form-check-input mt-1 me-2 cursor-pointer"
                                            type="checkbox"
                                            name='sameasdefaultaddress'
                                            checked={sameAddress}
                                            onChange={(e) => {
                                                const isChecked = e.target.checked;
                                                setSameAddress(isChecked);
                                                setBillingDetails(prev => ({
                                                    ...prev,
                                                    street1: isChecked ? shippingDetails.Street1 : prev.street1,
                                                    street2: isChecked ? shippingDetails.Street2 : prev.street2,
                                                    state: isChecked ? shippingDetails.state : prev.state,
                                                    city: isChecked ? shippingDetails.city : prev.city,
                                                    postalcode: isChecked ? shippingDetails.postalcode : prev.postalcode,
                                                }));

                                            }}
                                        />
                                        <label className="form-check-label font-13">
                                            Same as Shipping Address?
                                        </label>
                                    </div>
                                    <div className="col-xl-4 col-12 pt-3 ">
                                        <div className='col-12 text-start font-13 px-1 pb-1 new-font-style'>First Name<label className='redText'>*</label></div>
                                        <input type="text" autoComplete='off' name='billingfirstname'
                                            className="form-control" required value={billingDetails.firstname}
                                            onChange={(e) => setBillingDetails({ ...billingDetails, firstname: e.target.value })} />
                                        <span className="form-text invalid-feedback" >
                                            *required
                                        </span>
                                    </div>
                                    <div className="col-xl-4 col-12 pt-3 ">
                                        <div className='col-12 text-start font-13 px-1 pb-1 new-font-style'>Last Name<label className='redText'>*</label></div>
                                        <input type="text" autoComplete='off' name='billinglastname' className="form-control" required
                                            value={billingDetails.lastname} onChange={(e) => setBillingDetails({ ...billingDetails, lastname: e.target.value })}
                                        />
                                        <span className="form-text invalid-feedback" >
                                            *required
                                        </span>
                                    </div>
                                    <div className="col-xl-4 col-12 pt-3 ">
                                        <div className='col-12 text-start font-13 px-1 pb-1 new-font-style'>Email<label className='redText'>*</label></div>
                                        <input type="text" autoComplete='off' name='billingemail' className="form-control" required
                                            value={billingDetails.email} onChange={(e) => setBillingDetails({ ...billingDetails, email: e.target.value })}
                                        />
                                        <span className="form-text invalid-feedback" >
                                            *required
                                        </span>
                                        <span className="Emailinvalid" >
                                            {EmailValidation}
                                        </span>
                                    </div>

                                    <div className="col-xl-3 pe-0 col-12 pt-3 ">
                                        <div className='col-12 text-start font-13 px-1 pb-1 new-font-style'>Phone Number<label className='redText'>*</label></div>
                                        <input type="text" autoComplete='off' name='billingphoneno' className="form-control" required
                                            value={billingDetails.phoneno}
                                            onChange={(e) => {
                                                const onlyNumbers = e.target.value.replace(/\D/g, ''); // Remove all non-digit characters
                                                setBillingDetails({ ...billingDetails, phoneno: onlyNumbers });
                                            }}

                                        />
                                        <span className="form-text invalid-feedback" >
                                            *required
                                        </span>
                                    </div>
                                    <div className="col-xl-1 col-12 pt-3 ps-0">
                                        <div className='col-12 text-start font-13 px-1 pb-1 new-font-style'>Ext</div>
                                        <input type="text" autoComplete='off' name='billingextension' className="form-control"
                                            value={billingDetails.billingextension}
                                            onChange={(e) => {
                                                const onlyNumbers = e.target.value.replace(/\D/g, ''); // Remove all non-digit characters
                                                setBillingDetails({ ...billingDetails, billingextension: onlyNumbers });
                                            }}
                                        />
                                        <span className="form-text invalid-feedback" >
                                            *required
                                        </span>
                                    </div>


                                    <div className="col-xl-4 col-12 pt-3 ">
                                        <div className='col-12 text-start font-13 px-1 pb-1 new-font-style'>Company Name<label className='redText'>*</label></div>
                                        <input type="text" autoComplete='off' name='billingcompanyname' className="form-control" required
                                            value={billingDetails.companyname} onChange={(e) => setBillingDetails({ ...billingDetails, companyname: e.target.value })}
                                        />
                                        <span className="form-text invalid-feedback" >
                                            *required
                                        </span>
                                    </div>
                                    <div className="col-xl-4 col-12 pt-3 ">
                                        <div className='col-12 text-start font-13 px-1 pb-1 new-font-style'>Street Line 1<label className='redText'>*</label></div>
                                        <input type="text" autoComplete='off' name='billingstreet1' className="form-control" required
                                            value={billingDetails.street1} onChange={(e) => setBillingDetails({ ...billingDetails, street1: e.target.value })}
                                        />
                                        <span className="form-text invalid-feedback" >
                                            *required
                                        </span>
                                    </div>
                                    <div className="col-xl-4 col-12 pt-3 ">
                                        <div className='col-12 text-start font-13 px-1 pb-1 new-font-style'>Street Line 2</div>
                                        <input type="text" autoComplete='off' name='billingstreet2' className="form-control"
                                            value={billingDetails.street2} onChange={(e) => setBillingDetails({ ...billingDetails, street2: e.target.value })}
                                        />
                                    </div>
                                    <div className="col-xl-4 col-12 pt-3 ">
                                        <div className='col-12 text-start font-13 px-1 pb-1 new-font-style'>City<label className='redText'>*</label></div>
                                        <input type="text" autoComplete='off' name='billingcity' className="form-control" required
                                            value={billingDetails.city}
                                            onChange={(e) => {
                                                setBillingDetails(prev => ({ ...prev, city: e.target.value }));
                                                setBillingCityTouched(true);
                                            }}
                                        />
                                        <span className="form-text invalid-feedback" >
                                            *required
                                        </span>
                                    </div>
                                    <div className="col-xl-4 col-12 pt-3">
                                        <div className='col-12 text-start font-13 px-1 pb-1 new-font-style'>State<label className='redText'>*</label></div>
                                        <select required name='billingstate' value={billingDetails.state}
                                            onChange={(e) => {
                                                setBillingDetails(prev => ({ ...prev, state: e.target.value }));
                                                setBillingStateTouched(true);
                                            }}
                                        >
                                            <option value="0">Select</option>
                                            {AllState.map((item, i) => {
                                                return <option key={i} value={item.state_code} >{item.state_code}</option>
                                            })}
                                        </select>
                                        <span className="form-text invalid-feedback" >
                                            *required
                                        </span>
                                    </div>
                                    <div className="col-xl-4 col-12 pt-3 ">
                                        <div className='col-12 text-start font-13 px-1 pb-1 new-font-style'>Zip Code<label className='redText'>*</label></div>
                                        <input type="number" autoComplete='off' name='billingpostalcode' className="form-control" required
                                            value={billingDetails.postalcode}
                                            onChange={(e) => {
                                                setBillingDetails(prev => ({ ...prev, postalcode: e.target.value }));
                                                setBillingZipTouched(true);
                                            }}
                                        />
                                        <span className="form-text invalid-feedback" >
                                            *required
                                        </span>
                                    </div>
                                    {fromadminorschool != 2 ?
                                        <div className='col-md-4 col-12 pt-3'>
                                            <div className='col-12 text-start font-13 px-1 pb-1 new-font-style'>Account Credit</div>
                                            <div className="input-group">
                                                <span className="input-group-text">$</span>
                                                <input type="number" autoComplete='off' className="form-control"
                                                    name='accountcredit'
                                                    placeholder='00' pattern="[0-9]+(\.[0-9]+)?"
                                                    value={billingDetails.accountcredit}
                                                    disabled
                                                />
                                            </div>
                                        </div> :
                                        <div className='col-md-4 col-12 pt-3'>
                                            <div className='col-12 text-start font-13 px-1 pb-1 new-font-style'>Account Credit<label className='redText'>*</label></div>
                                            <div className="input-group">
                                                <span className="input-group-text">$</span>
                                                <input type="number" required autoComplete='off' className="form-control"
                                                    name='accountcredit'
                                                    placeholder='00' pattern="[0-9]+(\.[0-9]+)?"
                                                    value={billingDetails.accountcredit} onChange={(e) => setBillingDetails({ ...billingDetails, accountcredit: e.target.value })}
                                                    disabled={fromadminorschool != 2}
                                                />
                                                <span className="form-text invalid-feedback">  *required</span>
                                            </div>
                                        </div>
                                    }
                                    {fromadminorschool == 2 &&
                                        <div className='row'>
                                            <div className="col-xl-4 col-12 pt-3">
                                                <div style={{ border: "1px solid #e2e3e4", borderRadius: "0.3rem" }} className='p-2 h-100'>
                                                    <div className='col-12 text-start px-1 pb-1 new-font-style'>Account Credit Usage<label className='redText'>*</label></div>
                                                    <div className='col-md-12 font-13 ps-3'>
                                                        {accountCreditUsage.map((account, index) => (
                                                            <div className="col-md-2 font-13 d-flex align-items-center" key={index}>
                                                                <input
                                                                    id={`accountcredit-${account.id}`}
                                                                    className="form-check-input mt-1 me-2 cursor-pointer"
                                                                    type="checkbox"
                                                                    name='accountcreditusage'
                                                                    aria-label={account.id}
                                                                    checked={billingDetails?.accountcreditusage?.includes(String(account.id)) || false}
                                                                    onChange={(e) => {
                                                                        const isChecked = e.target.checked;
                                                                        const idString = String(account.id);
                                                                        setBillingDetails((prevState) => {
                                                                            const existingUsage = prevState?.accountcreditusage ?? [];
                                                                            return {
                                                                                ...prevState,
                                                                                accountcreditusage: isChecked
                                                                                    ? [...existingUsage.map(String), idString] // Add ID if checked
                                                                                    : existingUsage.filter((item) => String(item) !== idString) // Remove if unchecked
                                                                            };
                                                                        });
                                                                    }}
                                                                />
                                                                <label htmlFor={`accountcredit-${account.id}`}
                                                                    className={`form-check-label ${billingDetails?.accountcreditusage?.includes(String(account.id)) ? 'fw-bold' : ''
                                                                        }`}
                                                                >
                                                                    {account.name}
                                                                </label>
                                                            </div>
                                                        ))}
                                                    </div>
                                                    <span className="Emailinvalid" >
                                                        {errors.accountcreditError}
                                                    </span>
                                                </div>
                                            </div>
                                            <div className="col-xl-4 col-12 pt-3">
                                                <div style={{ border: "1px solid #e2e3e4", borderRadius: "0.3rem" }} className='p-2 h-100'>
                                                    <div className='col-12 text-start px-1 pb-1 new-font-style'>Pricing<label className='redText'>*</label></div>
                                                    <div className='col-md-12 font-13 ps-3'>
                                                        <div className="form-check">
                                                            <input
                                                                className="form-check-input"
                                                                type="radio"
                                                                name='pricing'
                                                                checked={SchoolProfile.pricing == 1}
                                                                onChange={(e) => setSchoolProfile({ ...SchoolProfile, pricing: 1 })}
                                                            />
                                                            <label className={`form-check-label ${SchoolProfile.pricing == 1 ? 'fw-bold' : ''}`}>Default</label>
                                                        </div>
                                                        <div className="form-check">
                                                            <input
                                                                className="form-check-input"
                                                                type="radio"
                                                                name='pricing'
                                                                checked={SchoolProfile.pricing == 2}
                                                                onChange={(e) => setSchoolProfile({ ...SchoolProfile, pricing: 2 })}
                                                            />
                                                            <label className={`form-check-label ${SchoolProfile.pricing == 2 ? 'fw-bold' : ''}`}>Custom</label>
                                                        </div>
                                                    </div>
                                                    <span className="Emailinvalid" >
                                                        {errors.pricingError}
                                                    </span>
                                                    {SchoolProfile.pricing == 2 &&
                                                        <div className="col-12 pt-4 ">
                                                            <div className='col-12 text-start font-13 px-1 pb-1 new-font-style'>Special Discounts or Pricing</div>
                                                            <textarea rows={1} autoComplete='off' name='billingspecialdiscount' className="form-control"
                                                                value={billingDetails.discoutpricing} onChange={(e) => setBillingDetails({ ...billingDetails, discoutpricing: e.target.value })}
                                                            />
                                                        </div>
                                                    }
                                                </div>
                                            </div>

                                        </div>
                                    }
                                </div>
                                <div className="col-12 text-end py-3">
                                    <button className="SaveBtn" onClick={(e) => handleSaveSection('BillingDetailsDiv', validateBillingExtras)}>Save Billing Information</button>
                                    <label className="ms-4 cursor-pointer" onClick={(e) => { fromadminorschool == 2 ? navigate("/schools") : navigate("/dashboard") }}><u>Exit</u></label>
                                </div>
                            </div>
                        </div>

                        {/* device information section*/}
                        <div className='pt-3'>
                            <div className='col-12 pb-2'>
                                <label className='schoolprofile-headers'>Device Information</label>
                            </div>
                            <div className="GridBox  p-2 align-items-center parent" id='DeviceDetailsDiv' >
                                <div className='row '>
                                    <div className="col-xl-6 col-12 pt-3">
                                        <div style={{ border: "1px solid #e2e3e4", borderRadius: "0.3rem" }} className='p-2 h-100'>
                                            <div className='col-12 text-start px-1 pb-1 new-font-style'>Devices in District<label className='redText'>*</label></div>
                                            <div className='col-md-12 font-13 ps-3 row'>
                                                {deviceDistricts.map((brand, index) => (
                                                    <div className="col-6 font-13 pb-1 d-flex align-items-center" key={index}>
                                                        <input
                                                            id={`device-${brand.id}`}
                                                            className="form-check-input mt-0 me-2 cursor-pointer"
                                                            type="checkbox"
                                                            name='devicesindistrict'
                                                            checked={deviceInformation?.devicesindistrict?.includes(String(brand.id)) || false}
                                                            onChange={(e) => handleDeviceDistrictCheckboxChange(e, brand.id)}
                                                        />
                                                        <label htmlFor={`device-${brand.id}`}
                                                            className={`form-check-label ${deviceInformation?.devicesindistrict?.includes(String(brand.id)) ? 'fw-bold' : ''
                                                                }`}
                                                        >
                                                            {brand.name}
                                                        </label>
                                                    </div>
                                                ))}
                                            </div>
                                            <span className="Emailinvalid" >
                                                {errors.deviceDistrictsError}
                                            </span>
                                        </div>
                                    </div>
                                    <div className="col-xl-6 col-12 pt-3 ">
                                        <div className='col-12 text-start font-13 px-1 pb-1 new-font-style'>
                                            How many loaner devices do you have? We recommend between 2-4%.<label className='redText'>*</label></div>
                                        <input type="number" autoComplete='off' name='countofloaner' className="form-control" required
                                            value={loanerAsset.countofLoanerDevice} onChange={(e) => setLoanerAsset({ ...loanerAsset, countofLoanerDevice: e.target.value })}
                                        />
                                        <span className="form-text invalid-feedback" >
                                            *required
                                        </span>
                                    </div>
                                </div>

                                <div className="col-12 text-end pt-4">
                                    <button className="SaveBtn" onClick={(e) => handleSaveSection('DeviceDetailsDiv', validateDeviceDetails)}>Save Device Information</button>
                                    <label className="ms-4 cursor-pointer" onClick={(e) => { fromadminorschool == 2 ? navigate("/schools") : navigate("/dashboard") }}><u>Exit</u></label>

                                </div>
                            </div>
                        </div>

                        {/* repair details section */}
                        <div className='pt-3'>
                            <div className='col-12 pb-2'>
                                <label className='schoolprofile-headers'>Repair Information</label>
                            </div>
                            <div className="GridBox  p-2  align-items-center parent" id="RepairDetailsDiv" >
                                <div className='row'>
                                    <div className='row'>
                                        <div className="col-xl-4 col-12 pt-3 ">
                                            <div className='col-12 text-start px-1 font-13 pb-1 new-font-style'>Weekly Repairs</div>
                                            <input type="text" autoComplete='off' name='weeklyrepairs' className="form-control"
                                                value={deviceInformation.weeklyrepairs} disabled />
                                        </div>
                                        <div className="col-xl-4 col-12 pt-3 ">
                                            <div className='col-12 text-start px-1 pb-1 new-font-style'>Repair Notes{fromadminorschool == 2 && <label className='redText'>*</label>}</div>
                                            {fromadminorschool == 2 ?
                                                <>
                                                    <textarea rows={1} autoComplete='off' name='repairnotes' className="form-control" required
                                                        value={repairDetails.repairNotes} onChange={(e) => setRepairDetails({ ...repairDetails, repairNotes: e.target.value })}
                                                    />
                                                    <span className="form-text invalid-feedback" >
                                                        *required
                                                    </span>
                                                </>
                                                :
                                                <textarea rows={1} autoComplete='off' className="form-control"
                                                    value={repairDetails.repairNotes} disabled
                                                />
                                            }

                                        </div>
                                    </div>
                                    {fromadminorschool == 2 &&
                                        <>
                                            <div className="col-xl-4 col-12 pt-3 ">
                                                <div style={{ border: "1px solid #e2e3e4", borderRadius: "0.3rem" }} className='p-2 h-100'>
                                                    <div className='col-12 text-start px-1 pb-1 new-font-style'>Minimum Repair Grade<label className='redText'>*</label></div>
                                                    <div className='col-md-12 font-13 ps-3 '>
                                                        {minimumRepairGrade.map((repairgrade, index) => (
                                                            <div className="font-13 ps-3 d-flex align-items-center" key={index}>
                                                                <input
                                                                    id={`repairgrade-${repairgrade.id}`}
                                                                    className="form-check-input me-2 cursor-pointer"
                                                                    type="radio"
                                                                    aria-label={repairgrade.id}
                                                                    name='minRepairGrade'
                                                                    checked={repairDetails.minRepairGrade == repairgrade.id}
                                                                    onChange={(e) => setRepairDetails({ ...repairDetails, minRepairGrade: repairgrade.id })}
                                                                />
                                                                <label htmlFor={`repairgrade-${repairgrade.id}`}
                                                                    className={`form-check-label ${repairDetails.minRepairGrade == repairgrade.id ? 'fw-bold' : ''}`}>

                                                                    {repairgrade.name}
                                                                </label>
                                                            </div>
                                                        ))}
                                                    </div>
                                                    <span className="Emailinvalid" >
                                                        {errors.minRepairGradeError}
                                                    </span>
                                                </div>
                                            </div>
                                            <div className="col-xl-4 col-12 pt-3 ">
                                                <div style={{ border: "1px solid #e2e3e4", borderRadius: "0.3rem" }} className='p-2 h-100'>
                                                    <div className='col-12 text-start px-1 pb-1 new-font-style'>Repair Price Tier<label className='redText'>*</label></div>
                                                    <div className='col-md-12 font-13 ps-3 '>
                                                        {repairPriceTier.map((repairprice, index) => (
                                                            <div className="font-13 ps-3 d-flex align-items-center" key={index}>
                                                                <input
                                                                    id={`repairpricetier-${repairprice.id}`}
                                                                    className="form-check-input me-2 cursor-pointer"
                                                                    type="radio"
                                                                    aria-label={repairprice.id}
                                                                    name='repairPriceTier'
                                                                    checked={repairDetails.repairPriceTier == repairprice.id}
                                                                    onChange={(e) => setRepairDetails({ ...repairDetails, repairPriceTier: repairprice.id })}
                                                                />
                                                                <label htmlFor={`repairpricetier-${repairprice.id}`}
                                                                    className={`form-check-label ${repairDetails.repairPriceTier == repairprice.id ? 'fw-bold' : ''}`}
                                                                >
                                                                    {repairprice.name}
                                                                </label>
                                                            </div>
                                                        ))}
                                                    </div>
                                                    <span className="Emailinvalid" >
                                                        {errors.repairPriceTierError}
                                                    </span>
                                                    {repairDetails.repairPriceTier == 4 &&
                                                        <div className="col-12 pt-3">
                                                            <div className='col-12 text-start px-1 pb-1 new-font-style'>Notes</div>
                                                            <textarea rows={1} autoComplete='off' name='deductiblenotes' className="form-control"
                                                                value={repairDetails.repairpricetiernotes} onChange={(e) => setRepairDetails({ ...repairDetails, repairpricetiernotes: e.target.value })}
                                                            />
                                                        </div>
                                                    }
                                                </div>
                                            </div>
                                            <div className="col-xl-4 col-12 pt-3 ">
                                                <div style={{ border: "1px solid #e2e3e4", borderRadius: "0.3rem" }} className='p-2 h-100'>
                                                    <div className='col-12 text-start pb-1 new-font-style'>Quoting Needed?<label className='redText'>*</label></div>
                                                    <div className='col-md-12 font-13 pt-2 ps-3'>
                                                        {quotingNeeded.map((quote, index) => (
                                                            <div className="font-13 ps-3 d-flex align-items-center" key={index}>
                                                                <input
                                                                    id={`quotingNeeded-${quote.id}`}
                                                                    className="form-check-input me-2 cursor-pointer"
                                                                    type="radio"
                                                                    aria-label={quote.id}
                                                                    name='quotingNeeded'
                                                                    checked={repairDetails.quotingNeeded == quote.id}
                                                                    onChange={(e) => setRepairDetails({ ...repairDetails, quotingNeeded: quote.id })}
                                                                />
                                                                <label htmlFor={`quotingNeeded-${quote.id}`}
                                                                    className={`form-check-label ${repairDetails.quotingNeeded == quote.id ? 'fw-bold' : ''}`}
                                                                >
                                                                    {quote.name}
                                                                </label>
                                                            </div>
                                                        ))}
                                                    </div>
                                                    <span className="Emailinvalid" >
                                                        {errors.quotingNeededError}
                                                    </span>
                                                </div>
                                            </div>
                                            <div className='col-xl-4 col-12 pt-3'>
                                                <div style={{ border: "1px solid #e2e3e4", borderRadius: "0.3rem" }} className='p-2 h-100'>
                                                    <div className='col-12 text-start px-1 pb-1 new-font-style'>Deductible?<label className='redText'>*</label></div>
                                                    <div className='col-md-12 font-13 ps-3'>
                                                        <div className="form-check">
                                                            <input
                                                                className="form-check-input"
                                                                type="radio"
                                                                name='deductible'
                                                                checked={repairDetails.deductible == 1}
                                                                onChange={(e) => setRepairDetails({ ...repairDetails, deductible: 1 })}
                                                            />
                                                            <label className={`form-check-label ${repairDetails.deductible == 1 ? 'fw-bold' : ''}`}>Yes</label>
                                                        </div>
                                                        <div className="form-check">
                                                            <input
                                                                className="form-check-input"
                                                                type="radio"
                                                                name='deductible'
                                                                checked={repairDetails.deductible == 2}
                                                                onChange={(e) => setRepairDetails({ ...repairDetails, deductible: 2 })}
                                                            />
                                                            <label className={`form-check-label ${repairDetails.deductible == 2 ? 'fw-bold' : ''}`}>No</label>
                                                        </div>
                                                    </div>
                                                    <span className="Emailinvalid" >
                                                        {errors.deductibleError}
                                                    </span>
                                                    {repairDetails.deductible == 1 ?
                                                        <div className="col-12 pt-3">
                                                            <div className='col-12 text-start px-1 pb-1 new-font-style'>Deductible Notes<label className='redText'>*</label></div>
                                                            <textarea rows={1} autoComplete='off' name='deductiblenotes' className="form-control" required
                                                                value={repairDetails.deductibleNotes} onChange={(e) => setRepairDetails({ ...repairDetails, deductibleNotes: e.target.value })}
                                                            />
                                                            <span className="form-text invalid-feedback" >
                                                                *required
                                                            </span>
                                                        </div>
                                                        :
                                                        <div className="col-12 pt-3">
                                                            <div className='col-12 text-start px-1 pb-1 new-font-style'>Deductible Notes</div>
                                                            <textarea rows={1} autoComplete='off' name='deductiblenotes' className="form-control"
                                                                value={repairDetails.deductibleNotes} onChange={(e) => setRepairDetails({ ...repairDetails, deductibleNotes: e.target.value })}
                                                            />
                                                        </div>
                                                    }
                                                </div>
                                            </div>

                                        </>
                                    }
                                    <div className='col-xl-4 col-12 pt-3'>
                                        <div style={{ backgroundColor: `${fromadminorschool != 2 && '#f0f0f1'}`, border: "1px solid #e2e3e4", borderRadius: "0.3rem" }} className='p-2 h-100'>
                                            <div className='col-12 text-start px-1 pb-1 new-font-style'>Cosmetic Damage Repaired?{fromadminorschool == 2 && <label className='redText'>*</label>}</div>
                                            <div className='col-md-12 font-13 ps-3'>
                                                <div className="form-check">
                                                    <input
                                                        className="form-check-input"
                                                        type="radio"
                                                        name='cosmeticDamageRepaird'
                                                        disabled={fromadminorschool != 2}
                                                        checked={repairDetails.cosmeticDamageRepaird == 1}
                                                        onChange={(e) => setRepairDetails({ ...repairDetails, cosmeticDamageRepaird: 1 })}
                                                    />
                                                    <label className={`form-check-label ${repairDetails.cosmeticDamageRepaird == 1 ? 'fw-bold' : ''}`}
                                                    >Yes</label>
                                                </div>
                                                <div className="form-check">
                                                    <input
                                                        className="form-check-input"
                                                        type="radio"
                                                        name='cosmeticDamageRepaird'
                                                        disabled={fromadminorschool != 2}
                                                        checked={repairDetails.cosmeticDamageRepaird == 2}
                                                        onChange={(e) => setRepairDetails({ ...repairDetails, cosmeticDamageRepaird: 2 })}
                                                    />
                                                    <label className={`form-check-label ${repairDetails.cosmeticDamageRepaird == 2 ? 'fw-bold' : ''}`}>No</label>
                                                </div>
                                            </div>
                                            <span className="Emailinvalid" >
                                                {errors.cosmeticDamageRepairdError}
                                            </span>
                                            {repairDetails.cosmeticDamageRepaird == 1 &&
                                                <div className='col-12 row ps-2'>
                                                    <div className='col-12 text-start px-1 new-font-style'>Select Damage Repaired<label className='redText'>*</label></div>
                                                    {cosmeticDamage.map((cosmetic, index) => (
                                                        <div className="col-md-6 font-13 d-flex align-items-center" key={index}>
                                                            <input
                                                                id={`cosmeticdamage-${cosmetic.id}`}
                                                                className="form-check-input mt-1 me-2 cursor-pointer"
                                                                type="checkbox"
                                                                name='cosmeticdamage'
                                                                aria-label={cosmetic.id}
                                                                disabled={fromadminorschool != 2}
                                                                checked={repairDetails?.selectedDamageRepaird?.includes(String(cosmetic.id)) || false}
                                                                onChange={(e) => handleCosmeticDamageCheckboxChange(e, cosmetic.id)}
                                                            />
                                                            <label htmlFor={`cosmeticdamage-${cosmetic.id}`}
                                                                className={`form-check-label ${repairDetails?.selectedDamageRepaird?.includes(String(cosmetic.id)) ? 'fw-bold' : ''}`}
                                                            >
                                                                {cosmetic.name}
                                                            </label>
                                                        </div>
                                                    ))}
                                                    <span className="Emailinvalid" >
                                                        {errors.selectedcosmeticDamageRepairdError}
                                                    </span>
                                                </div>

                                            }
                                            {repairDetails.cosmeticDamageRepaird == 1 ?
                                                <div className="col-12 pt-3">
                                                    <div className='col-12 text-start px-1 pb-1 new-font-style'>Cosmetic Damage Notes<label className='redText'>*</label></div>
                                                    <textarea rows={1} autoComplete='off' name='cosmeticdamagenotes' className="form-control" required
                                                        value={repairDetails.cosmeticdamageNotes} onChange={(e) => setRepairDetails({ ...repairDetails, cosmeticdamageNotes: e.target.value })}
                                                        disabled={fromadminorschool != 2}
                                                    />
                                                    <span className="form-text invalid-feedback" >
                                                        *required
                                                    </span>
                                                </div>
                                                : <div className="col-12 pt-3">
                                                    <div className='col-12 text-start px-1 pb-1 new-font-style'>Cosmetic Damage Notes</div>
                                                    <textarea rows={1} autoComplete='off' name='cosmeticdamagenotes' className="form-control"
                                                        value={repairDetails.cosmeticdamageNotes} onChange={(e) => setRepairDetails({ ...repairDetails, cosmeticdamageNotes: e.target.value })}
                                                        disabled={fromadminorschool != 2}
                                                    />
                                                </div>
                                            }
                                        </div>
                                    </div>
                                    <div className='col-xl-4 col-12 pt-3'>
                                        <div style={{ backgroundColor: `${fromadminorschool != 2 && '#f0f0f1'}`, border: "1px solid #e2e3e4", borderRadius: "0.3rem" }} className='p-2 h-100'>
                                            <div className='col-12 text-start px-1 pb-1 new-font-style'>Pick-Up Day{fromadminorschool == 2 && <label className='redText'>*</label>}</div>
                                            {routeDay.map((day, index) => (
                                                <div className="font-13 d-flex ps-3 align-items-center" key={index}>
                                                    <input
                                                        id={`routeday-${day.id}`}
                                                        className="form-check-input mt-1 me-2 cursor-pointer"
                                                        type="radio"
                                                        aria-label={day.id}
                                                        name="routeDay"
                                                        checked={repairDetails.routeDay == day.id}
                                                        disabled={fromadminorschool != 2}
                                                        onChange={(e) => setRepairDetails({ ...repairDetails, routeDay: day.id })}
                                                    />
                                                    <label htmlFor={`routeday-${day.id}`} className={`form-check-label ${repairDetails.routeDay == day.id ? 'fw-bold' : ''}`}>
                                                        {day.name}
                                                    </label>
                                                </div>
                                            ))}
                                            <span className="Emailinvalid" >
                                                {errors.routeDayError}
                                            </span>
                                        </div>

                                    </div>
                                    <div className='col-xl-4 col-12 pt-3'>
                                        <div style={{ backgroundColor: `${fromadminorschool != 2 && '#f0f0f1'}`, border: "1px solid #e2e3e4", borderRadius: "0.3rem" }} className='p-2 h-100'>
                                            <div className='col-12 text-start px-1 pb-1 new-font-style'>Route Frequency{fromadminorschool == 2 && <label className='redText'>*</label>}</div>
                                            {routeFrequency.map((route, index) => (
                                                <div className="font-13 ps-3 d-flex align-items-center" key={index}>
                                                    <input
                                                        id={`routefrequency-${route.id}`}
                                                        className="form-check-input me-2 cursor-pointer"
                                                        type="radio"
                                                        aria-label={route.id}
                                                        name='routeFrequency'
                                                        checked={repairDetails.routeFrequency == route.id}
                                                        disabled={fromadminorschool != 2}
                                                        onChange={(e) => setRepairDetails({ ...repairDetails, routeFrequency: route.id })}
                                                    />
                                                    <label htmlFor={`routefrequency-${route.id}`} className={`form-check-label ${repairDetails.routeFrequency == route.id ? 'fw-bold' : ''}`}>
                                                        {route.name}
                                                    </label>
                                                </div>
                                            ))}
                                            <span className="Emailinvalid" >
                                                {errors.routeFrequencyError}
                                            </span>
                                        </div>

                                    </div>
                                    <div className='col-xl-4 col-12 pt-3'>
                                        <div style={{ border: "1px solid #e2e3e4", borderRadius: "0.3rem" }} className='p-2 h-100'>
                                            <div className='col-12 text-start px-1 pb-1 new-font-style'>What should we do if we receive devices that are not covered?<label className='redText'>*</label></div>
                                            <div className='col-md-12 font-13 ps-3'>
                                                {uncoveredDevices.map((quote, index) => (
                                                    <div className="font-13 ps-3 d-flex align-items-center" key={index}>
                                                        <input
                                                            id={`uncoveredDevices-${quote.id}`}
                                                            className="form-check-input me-2 cursor-pointer"
                                                            type="radio"
                                                            aria-label={quote.id}
                                                            name='uncovereddevice'
                                                            checked={repairDetails.uncovereddevice == quote.id}
                                                            onChange={(e) => setRepairDetails({ ...repairDetails, uncovereddevice: quote.id })}
                                                        />
                                                        <label htmlFor={`uncoveredDevices-${quote.id}`} className={`form-check-label ${repairDetails.uncovereddevice == quote.id ? 'fw-bold' : ''}`}>
                                                            {quote.name}
                                                        </label>
                                                    </div>
                                                ))}

                                            </div>
                                            <span className="Emailinvalid" >
                                                {errors.uncovereddeviceError}
                                            </span>
                                            {repairDetails.uncovereddevice == 4 &&
                                                <div className='col-12 pt-3'>
                                                    <div className='col-12 font-13 text-start pb-1 new-font-style'>
                                                        Describe what to do
                                                    </div>
                                                    <textarea rows={2} autoComplete='off' name='describewhattodo' className="form-control"
                                                        value={repairDetails.uncovereddeviceNotes} onChange={(e) => setRepairDetails({ ...repairDetails, uncovereddeviceNotes: e.target.value })}
                                                    />
                                                </div>
                                            }
                                        </div>
                                    </div>
                                    <div className='col-xl-4 col-12 pt-3'>
                                        <div style={{ border: "1px solid #e2e3e4", borderRadius: "0.3rem" }} className='p-2 h-100'>
                                            <div className='col-12 text-start px-1 pb-1 new-font-style'>Additional Asset Management<label className='redText'>*</label></div>
                                            <div className='col-md-12 font-13 ps-3'>
                                                {additionalAssetManagement.map((assets, index) => (
                                                    <div className="font-13" key={index}>
                                                        <input
                                                            id={`assets-${assets.id}`}
                                                            className="form-check-input mt-1 me-2 cursor-pointer"
                                                            type="checkbox"
                                                            name='additionalAssets'
                                                            aria-label={assets.id}
                                                            checked={loanerAsset?.additionalAssets?.includes(String(assets.id))}
                                                            onChange={(e) => handleAdditionalAssetManagementCheckboxChange(e, assets.id)}
                                                        />
                                                        <label htmlFor={`assets-${assets.id}`}
                                                            className={`form-check-label ${loanerAsset?.additionalAssets?.includes(String(assets.id)) ? 'fw-bold' : ''
                                                                }`}
                                                        >
                                                            {assets.name}
                                                        </label>
                                                    </div>
                                                ))}
                                            </div>
                                            <span className="Emailinvalid" >
                                                {errors.assetManagementError}
                                            </span>
                                            {loanerAsset?.additionalAssets?.includes("5") &&
                                                <div className='col-12 pt-3'>
                                                    <div className='col-12 font-13 text-start pb-1 new-font-style'>
                                                        Notes
                                                    </div>
                                                    <textarea rows={2} autoComplete='off' name='additionalassetnotes' className="form-control"
                                                        value={repairDetails.additionalAssetNotes} onChange={(e) => setRepairDetails({ ...repairDetails, additionalAssetNotes: e.target.value })}
                                                    />
                                                </div>
                                            }
                                        </div>
                                    </div>

                                    <Accordion activeKey={activeKeys}>
                                        <Accordion.Item eventKey="0" className='mt-2'>
                                            <Accordion.Header onClick={() => toggleKey('0')}>Repair Cap<label className='redText'>*</label></Accordion.Header>
                                            <Accordion.Body style={{ background: "white" }}>
                                                <div className='row'>
                                                    <div className='col-md-3 font-13 text-start new-font-style'>Device Type</div>
                                                    <div className='col-md-3 font-13 text-start new-font-style'>Repair Cap</div>
                                                    <div className='col-md-3 font-13 text-start new-font-style'>Repair Cap Exceeded</div>
                                                </div>

                                                {repairCapRows.map((row, index) => (
                                                    row.flag != 3 &&
                                                    <div className='pt-2 row' key={index}>
                                                        <div className='col-md-3'>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                required
                                                                value={row.deviceType}
                                                                onChange={(e) => handleRepairCapChange(index, "deviceType", e.target.value)}
                                                                placeholder="Enter device type"
                                                            />
                                                            <span className="form-text invalid-feedback">  *required</span>
                                                        </div>
                                                        <div className='col-md-3'>
                                                            <div className="input-group ">
                                                                <span className="input-group-text">$</span>
                                                                <input type="number" required autoComplete='off' className="form-control"
                                                                    name='repaircap'
                                                                    placeholder='Enter cap amount' pattern="[0-9]+(\.[0-9]+)?"
                                                                    value={row.capAmount}
                                                                    onChange={(e) => handleRepairCapChange(index, "capAmount", e.target.value)}
                                                                />
                                                                <span className="form-text invalid-feedback">  *required</span>
                                                            </div>
                                                        </div>
                                                        <div className='col-md-3'>
                                                            <div className='col-md-12'>
                                                                <select required value={row.capexceeding} onChange={(e) => handleRepairCapChange(index, "capexceeding", e.target.value)}>
                                                                    <option value="0">Select</option>
                                                                    {exceedingCapHandling.map((caphandling, index) => (
                                                                        <option key={index} value={caphandling.id}>{caphandling.name}</option>
                                                                    ))}
                                                                </select>
                                                                <span className="form-text invalid-feedback" >
                                                                    *required
                                                                </span>
                                                            </div>
                                                        </div>
                                                        <div className='col-md-1'>
                                                            {repairCapRows.filter(r => r.flag != 3).length > 1 && (
                                                                <img
                                                                    src="/images/CancelIcon.svg"
                                                                    title='Remove'
                                                                    onClick={() => handleRemoveRepairCapRow(index)}
                                                                    style={{ cursor: 'pointer' }}
                                                                />
                                                            )}
                                                        </div>

                                                    </div>
                                                ))}

                                                <div className='col-12 pt-2'>
                                                    <label onClick={handleAddRepairCapRow} className="mt-2 text-decoration-underline cursor-pointer">
                                                        Add More
                                                    </label>
                                                </div>
                                            </Accordion.Body>
                                        </Accordion.Item>
                                        <Accordion.Item eventKey="1" className='mt-3'>
                                            <Accordion.Header onClick={() => toggleKey('1')}>Device Login<label className='redText'>*</label></Accordion.Header>
                                            <Accordion.Body style={{ background: "white" }}>
                                                {logins.map((login, index) => (
                                                    <div className='row py-2' key={login.uniqueId}>
                                                        <div className='col-md-4'>
                                                            <div className='col-md-12'>
                                                                <select required value={login.id} onChange={(e) => updateLogin(login.uniqueId, "id", parseInt(e.target.value))}>
                                                                    <option value="0">Select Device</option>
                                                                    <option value="1">Chromebook</option>
                                                                    <option value="2">Windows</option>
                                                                    <option value="3">iPad</option>
                                                                    <option value="4">MacBook</option>
                                                                </select>
                                                                <span className="form-text invalid-feedback" >
                                                                    *required
                                                                </span>
                                                            </div>
                                                        </div>
                                                        <div className='col-md-8'>
                                                            {login.credentials.map((cred, credindex) => (
                                                                cred.flag != 2 &&
                                                                <div key={cred.id} className="row pb-1 align-items-center">
                                                                    <div className='col-md-5'>
                                                                        <input className='form-control' required placeholder="Username" value={cred.username} onChange={(e) => updateCredential(login.uniqueId, cred.id, "username", e.target.value)} />
                                                                        <span className="form-text invalid-feedback" >
                                                                            *required
                                                                        </span>
                                                                    </div>
                                                                    <div className='col-md-5 position-relative'>
                                                                        <input className='form-control' required type={cred.showPassword ? "text" : "password"} placeholder="Password" value={cred.password} onChange={(e) => updateCredential(login.uniqueId, cred.id, "password", e.target.value)} />
                                                                        <span className="form-text invalid-feedback" >
                                                                            *required
                                                                        </span>
                                                                    </div>
                                                                    <div className='col-md-1 position-relative'>
                                                                        <button
                                                                            type="button"
                                                                            className="btn btn-sm position-absolute top-50 translate-middle-y"
                                                                            style={{ right: "-5%" }}
                                                                            onClick={() => togglePasswordVisibility(login.uniqueId, cred.id)}
                                                                        >
                                                                            {cred.showPassword ? <FontAwesomeIcon icon={faEyeSlash} /> : <FontAwesomeIcon icon={faEye} />}
                                                                        </button>
                                                                    </div>
                                                                    <div className='col-md-1'>
                                                                        {login.credentials.filter(r => r.flag != 2).length > 1 && (
                                                                            <img src="/images/CancelIcon.svg" title='Remove' onClick={() => removeCredential(login.uniqueId, cred.id)} />
                                                                        )}
                                                                    </div>
                                                                </div>
                                                            ))}
                                                            <div className='col-12 text-center'>
                                                                <label onClick={() => addCredential(login.uniqueId)} className="mt-2 text-decoration-underline cursor-pointer ">
                                                                    Add Another Login
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))}
                                                <span className="Emailinvalid" >
                                                    {deviceloginerror}
                                                </span>
                                                <div className='col-12 pt-3'>
                                                    <button onClick={addLogin} className="BorderBtn">
                                                        Add New Device
                                                    </button>
                                                </div>
                                            </Accordion.Body>
                                        </Accordion.Item>
                                        <Accordion.Item className='mt-3' eventKey="2">
                                            <Accordion.Header onClick={() => toggleKey('2')}>Repair Coverage{fromadminorschool == 2 && <label className='redText'>*</label>}</Accordion.Header>
                                            <Accordion.Body style={{ backgroundColor: `${fromadminorschool != 2 ? '#f0f0f1' : 'white'}` }}>
                                                <div className='row'>
                                                    {repairCoverage.map((repairs, index) => (
                                                        <div key={index} className="col-12 font-13 d-flex flex-column">
                                                            <div className="d-flex align-items-center">
                                                                <input
                                                                    id={`repairs-${repairs.id}`}
                                                                    className="form-check-input mt-1 me-2 cursor-pointer"
                                                                    type="checkbox"
                                                                    name='repairCoverage'
                                                                    aria-label={repairs.id}
                                                                    checked={repairDetails?.repairCoverage?.includes(String(repairs.id)) || false}
                                                                    disabled={fromadminorschool != 2}
                                                                    onChange={(e) => handleRepairCoverageCheckboxChange(e, repairs.id)}
                                                                />
                                                                <label htmlFor={`repairs-${repairs.id}`}
                                                                    className={`form-check-label ${repairDetails?.repairCoverage?.includes(String(repairs.id)) ? 'fw-bold' : ''
                                                                        }`}>
                                                                    {repairs.name}
                                                                </label>
                                                            </div>
                                                            {repairs.id == 1 && repairDetails?.repairCoverage?.includes(String(repairs.id)) && (
                                                                <div className='p-3'>
                                                                    {ASProws.map((row, index) => (
                                                                        <div style={{ border: "1px solid #e2e3e4", borderRadius: "0.3rem" }} key={index} className='p-2 mb-3'>
                                                                            <div className='pt-2 row'>
                                                                                <div className='col-md-3'>
                                                                                    <div className='col-12 text-start px-1 pb-1 font-12 new-font-style'>Device Type</div>
                                                                                    <select value={row.deviceType} name='devicetype'
                                                                                        style={{ backgroundColor: fromadminorschool != 2 && "#e9ecef" }}
                                                                                        onChange={(e) => handleASPRepairCoverageChange(index, "deviceType", e.target.value)}
                                                                                        disabled={fromadminorschool != 2}
                                                                                    >
                                                                                        <option value="0">Select</option>
                                                                                        {deviceDistricts?.map((item, i) => {
                                                                                            return <option key={i} value={item.id}>{item.name}</option>
                                                                                        })
                                                                                        }
                                                                                    </select>
                                                                                </div>
                                                                                <div className='col-md-3'>
                                                                                    <div className='col-12 text-start px-1 pb-1 font-12 new-font-style'>Device Model</div>
                                                                                    <input
                                                                                        type="text"
                                                                                        className="form-control"
                                                                                        value={row.deviceModel}
                                                                                        onChange={(e) => handleASPRepairCoverageChange(index, "deviceModel", e.target.value)}
                                                                                        disabled={fromadminorschool != 2}

                                                                                    />
                                                                                </div>
                                                                                <div className='col-md-3'>
                                                                                    <div className='col-12 text-start px-1 pb-1 font-12 new-font-style'>Coverage Type</div>
                                                                                    <select disabled={fromadminorschool != 2}
                                                                                        style={{ backgroundColor: fromadminorschool != 2 && "#e9ecef" }}
                                                                                        value={row.coverageType}
                                                                                        onChange={(e) => handleASPRepairCoverageChange(index, "coverageType", e.target.value)}>
                                                                                        <option value="0">Select</option>
                                                                                        <option value="CLW">CLW</option>
                                                                                        <option value="ADP">ADP</option>
                                                                                    </select>

                                                                                </div>
                                                                                <div className='col-md-3'>
                                                                                    <div className='col-12 text-start px-1 pb-1 font-12 new-font-style'>Coverage Start Date</div>
                                                                                    <input
                                                                                        type="date"
                                                                                        className="form-control"
                                                                                        value={row.startDate}
                                                                                        onChange={(e) => handleASPRepairCoverageChange(index, "startDate", e.target.value)}
                                                                                        disabled={fromadminorschool != 2}

                                                                                    />

                                                                                </div>
                                                                                <div className='col-md-3 pt-3'>
                                                                                    <div className='col-12 text-start px-1 pb-1 font-12 new-font-style'>Coverage End Date</div>
                                                                                    <input
                                                                                        type="date"
                                                                                        className="form-control"
                                                                                        value={row.endDate}
                                                                                        onChange={(e) => handleASPRepairCoverageChange(index, "endDate", e.target.value)}
                                                                                        list="coverageEndDates"
                                                                                        disabled={fromadminorschool != 2}

                                                                                    />
                                                                                </div>
                                                                                <div className='col-md-3 pt-3'>
                                                                                    <div className='col-12 text-start px-1 pb-1 font-12 new-font-style'>Carted</div>
                                                                                    <select disabled={fromadminorschool != 2}
                                                                                        style={{ backgroundColor: fromadminorschool != 2 && "#e9ecef" }}
                                                                                        value={row.carted}
                                                                                        onChange={(e) => handleASPRepairCoverageChange(index, "carted", e.target.value)}>
                                                                                        <option value="0">Select</option>
                                                                                        <option value="1">Yes</option>
                                                                                        <option value="2">No</option>
                                                                                    </select>
                                                                                </div>
                                                                                <div className='col-md-3 pt-3'>
                                                                                    <div className='col-12 text-start px-1 pb-1 font-12 new-font-style'>Cases</div>
                                                                                    <select disabled={fromadminorschool != 2}
                                                                                        style={{ backgroundColor: fromadminorschool != 2 && "#e9ecef" }}
                                                                                        value={row.cases}
                                                                                        onChange={(e) => handleASPRepairCoverageChange(index, "cases", e.target.value)}>
                                                                                        <option value="0">Select</option>
                                                                                        <option value="1">Yes</option>
                                                                                        <option value="2">No</option>
                                                                                        <option value="3">Sleeve</option>
                                                                                    </select>
                                                                                </div>
                                                                                <div className='col-md-3 pt-3'>
                                                                                    <div className='col-12 text-start px-1 pb-1 font-12 new-font-style'>Screen</div>
                                                                                    <select disabled={fromadminorschool != 2}
                                                                                        style={{ backgroundColor: fromadminorschool != 2 && "#e9ecef" }}
                                                                                        value={row.screen}
                                                                                        onChange={(e) => handleASPRepairCoverageChange(index, "screen", e.target.value)}>
                                                                                        <option value="0">Select</option>
                                                                                        <option value="1">Non-Touch</option>
                                                                                        <option value="2">Touch</option>
                                                                                        <option value="3">2-in-1</option>
                                                                                        <option value="4">Tablet </option>
                                                                                    </select>
                                                                                </div>
                                                                                {asperror === index && (
                                                                                    <div className='redText'>All fields are required!</div>
                                                                                )}
                                                                            </div>
                                                                        </div>
                                                                    ))}
                                                                    <div className='col-12 text-center pt-2'>
                                                                        <label onClick={handleAddNewASPRows} className="mt-2 text-decoration-underline cursor-pointer ">
                                                                            Add More
                                                                        </label>
                                                                    </div>
                                                                </div>
                                                            )}
                                                            {repairs.id == 2 && repairDetails?.repairCoverage?.includes(String(repairs.id)) && (
                                                                <div className='p-3'>
                                                                    <div className='row'>
                                                                        <div className='col-md-3'>
                                                                            <div className='col-12 text-start px-1 pb-1 font-12 new-font-style'>Carted</div>
                                                                            <select value={repairCoverageData.adhoc_carted} name='carted'
                                                                                style={{ backgroundColor: fromadminorschool != 2 && "#e9ecef" }}
                                                                                onChange={(e) => setRepairCoverageData({ ...repairCoverageData, adhoc_carted: e.target.value })}
                                                                                disabled={fromadminorschool != 2}
                                                                            >
                                                                                <option value="0">Select</option>
                                                                                <option value="1">Yes</option>
                                                                                <option value="2">No</option>
                                                                            </select>
                                                                        </div>
                                                                        <div className='col-md-3'>
                                                                            <div className='col-12 text-start px-1 pb-1 font-12 new-font-style'>Cases</div>
                                                                            <select value={repairCoverageData.adhoc_cases} name='cases'
                                                                                style={{ backgroundColor: fromadminorschool != 2 && "#e9ecef" }}
                                                                                onChange={(e) => setRepairCoverageData({ ...repairCoverageData, adhoc_cases: e.target.value })}
                                                                                disabled={fromadminorschool != 2}
                                                                            >
                                                                                <option value="0">Select</option>
                                                                                <option value="1">Yes</option>
                                                                                <option value="2">No</option>
                                                                                <option value="3">Sleeve</option>
                                                                            </select>
                                                                        </div>
                                                                        <div className='col-md-3 '>
                                                                            <div className='col-12 text-start px-1 pb-1 font-12 new-font-style'>Screen</div>
                                                                            <select value={repairCoverageData.adhoc_screen} name='screen'
                                                                                style={{ backgroundColor: fromadminorschool != 2 && "#e9ecef" }}
                                                                                onChange={(e) => setRepairCoverageData({ ...repairCoverageData, adhoc_screen: e.target.value })}
                                                                                disabled={fromadminorschool != 2}
                                                                            >
                                                                                <option value="0">Select</option>
                                                                                <option value="1">Non-Touch</option>
                                                                                <option value="2">Touch</option>
                                                                                <option value="3">2-in-1</option>
                                                                                <option value="4">Tablet</option>
                                                                            </select>
                                                                        </div>
                                                                    </div>
                                                                    <div className='redText'> {adhocerror}</div>

                                                                </div>
                                                            )}
                                                            {repairs.id == 3 && repairDetails?.repairCoverage?.includes(String(repairs.id)) && (
                                                                <div className='p-3'>
                                                                    {ADProws.map((row, index) => (
                                                                        <div style={{ border: "1px solid #e2e3e4", borderRadius: "0.3rem" }} key={index} className='p-2 mb-3'>
                                                                            <div className='pt-2 row'>
                                                                                <div className='col-md-3'>
                                                                                    <div className='col-12 text-start px-1 pb-1 font-12 new-font-style'>Device Type</div>
                                                                                    <select value={row.deviceType} name='devicetype'
                                                                                        style={{ backgroundColor: fromadminorschool != 2 && "#e9ecef" }}
                                                                                        onChange={(e) => handleADPRepairCoverageChange(index, "deviceType", e.target.value)}
                                                                                        disabled={fromadminorschool != 2}
                                                                                    >
                                                                                        <option value="0">Select</option>
                                                                                        {deviceDistricts?.map((item, i) => {
                                                                                            return <option key={i} value={item.id}>{item.name}</option>
                                                                                        })
                                                                                        }
                                                                                    </select>
                                                                                </div>
                                                                                <div className='col-md-3'>
                                                                                    <div className='col-12 text-start px-1 pb-1 font-12 new-font-style'>Device Model</div>

                                                                                    <input
                                                                                        type="text"
                                                                                        className="form-control"
                                                                                        value={row.deviceModel}
                                                                                        onChange={(e) => handleADPRepairCoverageChange(index, "deviceModel", e.target.value)}
                                                                                        disabled={fromadminorschool != 2}
                                                                                    />
                                                                                </div>

                                                                                <div className='col-md-3'>
                                                                                    <div className='col-12 text-start px-1 pb-1 font-12 new-font-style'>Parental Start Date</div>

                                                                                    <input
                                                                                        type="date"
                                                                                        className="form-control"
                                                                                        value={row.startDate}
                                                                                        onChange={(e) => handleADPRepairCoverageChange(index, "startDate", e.target.value)}
                                                                                        disabled={fromadminorschool != 2}
                                                                                    />

                                                                                </div>
                                                                                <div className='col-md-3'>
                                                                                    <div className='col-12 text-start px-1 pb-1 font-12 new-font-style'>Parental End Date</div>

                                                                                    <input
                                                                                        type="date"
                                                                                        className="form-control"
                                                                                        value={row.endDate}
                                                                                        onChange={(e) => handleADPRepairCoverageChange(index, "endDate", e.target.value)}
                                                                                        list="coverageEndDates"
                                                                                        disabled={fromadminorschool != 2}
                                                                                    />

                                                                                </div>
                                                                                <div className='col-md-3 pt-3'>
                                                                                    <div className='col-12 text-start px-1 pb-1 font-12 new-font-style'>Carted</div>
                                                                                    <select value={row.carted} name='carted'
                                                                                        style={{ backgroundColor: fromadminorschool != 2 && "#e9ecef" }}
                                                                                        onChange={(e) => handleADPRepairCoverageChange(index, "carted", e.target.value)}
                                                                                        disabled={fromadminorschool != 2}
                                                                                    >
                                                                                        <option value="0">Select</option>
                                                                                        <option value="1">Yes</option>
                                                                                        <option value="2">No</option>
                                                                                    </select>
                                                                                </div>
                                                                                <div className='col-md-3 pt-3'>
                                                                                    <div className='col-12 text-start px-1 pb-1 font-12 new-font-style'>Cases</div>
                                                                                    <select value={row.cases} name='cases'
                                                                                        style={{ backgroundColor: fromadminorschool != 2 && "#e9ecef" }}
                                                                                        onChange={(e) => handleADPRepairCoverageChange(index, "cases", e.target.value)}
                                                                                        disabled={fromadminorschool != 2}
                                                                                    >
                                                                                        <option value="0">Select</option>
                                                                                        <option value="1">Yes</option>
                                                                                        <option value="2">No</option>
                                                                                        <option value="3">Sleeve</option>
                                                                                    </select>
                                                                                </div>
                                                                                <div className='col-md-3 pt-3'>
                                                                                    <div className='col-12 text-start px-1 pb-1 font-12 new-font-style'>Screen</div>
                                                                                    <select value={row.screen} name='screen'
                                                                                        style={{ backgroundColor: fromadminorschool != 2 && "#e9ecef" }}
                                                                                        onChange={(e) => handleADPRepairCoverageChange(index, "screen", e.target.value)}
                                                                                        disabled={fromadminorschool != 2}
                                                                                    >
                                                                                        <option value="0">Select</option>
                                                                                        <option value="1">Non-Touch</option>
                                                                                        <option value="2">Touch</option>
                                                                                        <option value="3">2-in-1</option>
                                                                                        <option value="4">Tablet</option>
                                                                                    </select>
                                                                                </div>
                                                                                {adperror === index && (
                                                                                    <div className='redText'>All fields are required!</div>
                                                                                )}

                                                                            </div>
                                                                        </div>
                                                                    ))}
                                                                    <div className='col-12 text-center pt-2'>
                                                                        <label onClick={handleAddNewADPRows} className="mt-2 text-decoration-underline cursor-pointer ">
                                                                            Add More
                                                                        </label>
                                                                    </div>
                                                                </div>
                                                            )}
                                                            {repairs.id == 4 && repairDetails?.repairCoverage?.includes(String(repairs.id)) && (
                                                                <div className='p-3'>
                                                                    <div className='row'>
                                                                        <div className='col-md-3'>
                                                                            <div className='col-12 text-start px-1 pb-1 font-12 new-font-style'>Carted</div>
                                                                            <select value={repairCoverageData.parental_carted} name='carted'
                                                                                style={{ backgroundColor: fromadminorschool != 2 && "#e9ecef" }}
                                                                                onChange={(e) => setRepairCoverageData({ ...repairCoverageData, parental_carted: e.target.value })}
                                                                                disabled={fromadminorschool != 2}
                                                                            >
                                                                                <option value="0">Select</option>
                                                                                <option value="1">Yes</option>
                                                                                <option value="2">No</option>
                                                                            </select>
                                                                        </div>
                                                                        <div className='col-md-3'>
                                                                            <div className='col-12 text-start px-1 pb-1 font-12 new-font-style'>Cases</div>
                                                                            <select value={repairCoverageData.parental_cases} name='cases'
                                                                                style={{ backgroundColor: fromadminorschool != 2 && "#e9ecef" }}
                                                                                onChange={(e) => setRepairCoverageData({ ...repairCoverageData, parental_cases: e.target.value })}
                                                                                disabled={fromadminorschool != 2}
                                                                            >
                                                                                <option value="0">Select</option>
                                                                                <option value="1">Yes</option>
                                                                                <option value="2">No</option>
                                                                                <option value="3">Sleeve</option>
                                                                            </select>
                                                                        </div>
                                                                        <div className='col-md-3 '>
                                                                            <div className='col-12 text-start px-1 pb-1 font-12 new-font-style'>Screen</div>
                                                                            <select value={repairCoverageData.parental_screen} name='screen'
                                                                                style={{ backgroundColor: fromadminorschool != 2 && "#e9ecef" }}
                                                                                onChange={(e) => setRepairCoverageData({ ...repairCoverageData, parental_screen: e.target.value })}
                                                                                disabled={fromadminorschool != 2}
                                                                            >
                                                                                <option value="0">Select</option>
                                                                                <option value="1">Non-Touch</option>
                                                                                <option value="2">Touch</option>
                                                                                <option value="3">2-in-1</option>
                                                                                <option value="4">Tablet</option>
                                                                            </select>
                                                                        </div>
                                                                    </div>
                                                                    <div className='redText'> {coverageerror}</div>

                                                                </div>
                                                            )}
                                                        </div>
                                                    ))}
                                                </div>
                                                <span className="Emailinvalid" >
                                                    {errors.repairCoverageError}
                                                </span>
                                            </Accordion.Body>
                                        </Accordion.Item>
                                    </Accordion>
                                </div>
                                <div className="col-12 text-end py-3">
                                    <button className="SaveBtn" onClick={(e) => handleSaveSection('RepairDetailsDiv', validateRepairDetails)}>Save Repair Information</button>
                                    <label className="ms-4 cursor-pointer" onClick={(e) => { fromadminorschool == 2 ? navigate("/schools") : navigate("/dashboard") }}><u>Exit</u></label>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div >
            {buildingAddressPopup &&
                <BuildingAddressPopup setNewAlerts={setNewAlerts} getSchoolProfileInfo={getSchoolProfileInfo} setLoading={setLoading} buildingAddressPopup={buildingAddressPopup} selectedBuildingAddress={selectedBuildingAddress}
                    closePopup={(e) => { setBuildingAddressPopup(false); setSelectedBuildingAddress({}) }} />
            }
        </div >
    )
}
